// constants.jsx: Save all your constants in this file

import { MoistureIcon, NutritionIcon, ECIcon } from './CustomSvgIcons';

export const actionBtnWd = 244;
export const baseTimelineChartBoxWd = 165;
export const baseTimelineChartColGap = 2;
export const confirmationBoxMaxWd = 860;
export const contentMaxWd = 1440;
export const cropGridDayEntryMinWd = 116;
export const cropGridEntryColGap = 3;
export const cropGridEntryDayColGap = 1;
export const cropGridEntryRowGap = 2;
export const cropGridEntryMinWd = 152;
export const dashNavTotalWd = 258;
export const dashNavCollapsedWd = 53;
export const dashNavMr = 32;
export const dashNavWd = 226;
export const detailTextMaxWd = 650;
export const descTextareaHt = 200;
export const farmsTableMaxWd = 1420;
export const growDashMiniCardTableWd = 848;
export const inviteFormMaxWd = 544;
export const inProdInvRowTitleWd = 125;
export const maxExternalCardBoxHt = 196; // self
export const maxExternalCardBoxWd = 320; // self
export const maxAccordionCardsBoxHt = 504; // 4 * 126
export const maxForecastTableHt = 344; // 172 -> 344
// export const maxForecastTableWd = 882;
export const maxForecastTableWd = 1000;
export const maxHarvestTableWd = 510;
export const maxWidthStrainTableInGrowplan = 1060;
export const maxWrapperHt = 1024;
export const minPlansBtnHt = 56;
export const setupFormMaxWd = 472;

export const fadeTimingMs = 1000;
export const collapseTransition = 300;
export const transitionDuration = 800;
export const snackbarDefDuration = 6000;

export const disabledColor = 'rgba(0, 0, 0, 0.26)';
export const landingPageBgColor = '#0F1300';
export const lPAccessBtnBgColor = '#ECF9DD';
export const lPAccessBtnTxtColor = '#4A4A4A';
export const lPHeadlineTxtColor = '#EFFADD';

const ganttChartColorsNum = 6;
// const opacityList = ['FF', 'EE', 'DD', 'CC', 'BB', 'AA'];
// const opacityList = ['FF', 'E0', 'D0', 'C0', 'B0', 'A0'];
const opacityList = ['FF', 'DD', 'BB', '99', '77', '55'];
export const cropPlanGanttChartColors = (base = '#000000') =>
  Array.from({ length: ganttChartColorsNum })
    .fill(base)
    .map((color, idx) => color + opacityList[idx]);

export const millisInDay = 86400000;

// Tabs
// export const plansTabs = [
//         {key: 'grow-plans', entityLinkName: 'growplan', entityName: 'Grow Plan', label: 'My Grow Plans'},
//         {key: 'quality-plans', entityLinkName: 'qualityplan', entityName: 'Quality Plan', label: 'My Quality Plans'},
//         {key: 'metrics', entityLinkName: null, entityName: 'Metrics', label: 'My Metrics'},
//         {key: 'phases', entityLinkName: 'phaseplan', entityName: 'Phases', label: 'My Phases'},
//         {key: 'routines', entityLinkName: null, entityName: 'Routines', label: 'My Routines'},
// ];

// Choices
export const states = [
  { id: 'al', name: 'Alabama' },
  { id: 'ak', name: 'Alaska' },
  { id: 'as', name: 'American Samoa' },
  { id: 'az', name: 'Arizona' },
  { id: 'ar', name: 'Arkansas' },
  { id: 'ca', name: 'California' },
  { id: 'co', name: 'Colorado' },
  { id: 'ct', name: 'Connecticut' },
  { id: 'de', name: 'Delaware' },
  { id: 'dc', name: 'District Of Columbia' },
  { id: 'fm', name: 'Federated States Of Micronesia' },
  { id: 'fl', name: 'Florida' },
  { id: 'ga', name: 'Georgia' },
  { id: 'gu', name: 'Guam' },
  { id: 'hi', name: 'Hawaii' },
  { id: 'id', name: 'Idaho' },
  { id: 'il', name: 'Illinois' },
  { id: 'in', name: 'Indiana' },
  { id: 'ia', name: 'Iowa' },
  { id: 'ks', name: 'Kansas' },
  { id: 'ky', name: 'Kentucky' },
  { id: 'la', name: 'Louisiana' },
  { id: 'me', name: 'Maine' },
  { id: 'mh', name: 'Marshall Islands' },
  { id: 'md', name: 'Maryland' },
  { id: 'ma', name: 'Massachusetts' },
  { id: 'mi', name: 'Michigan' },
  { id: 'mn', name: 'Minnesota' },
  { id: 'ms', name: 'Mississippi' },
  { id: 'mo', name: 'Missouri' },
  { id: 'mt', name: 'Montana' },
  { id: 'ne', name: 'Nebraska' },
  { id: 'nv', name: 'Nevada' },
  { id: 'nh', name: 'New Hampshire' },
  { id: 'nj', name: 'New Jersey' },
  { id: 'nm', name: 'New Mexico' },
  { id: 'ny', name: 'New York' },
  { id: 'nc', name: 'North Carolina' },
  { id: 'nd', name: 'North Dakota' },
  { id: 'mp', name: 'Northern Mariana Islands' },
  { id: 'oh', name: 'Ohio' },
  { id: 'ok', name: 'Oklahoma' },
  { id: 'or', name: 'Oregon' },
  { id: 'pw', name: 'Palau' },
  { id: 'pa', name: 'Pennsylvania' },
  { id: 'pr', name: 'Puerto Rico' },
  { id: 'ri', name: 'Rhode Island' },
  { id: 'sc', name: 'South Carolina' },
  { id: 'sd', name: 'South Dakota' },
  { id: 'tn', name: 'Tennessee' },
  { id: 'tx', name: 'Texas' },
  { id: 'ut', name: 'Utah' },
  { id: 'vt', name: 'Vermont' },
  { id: 'vi', name: 'Virgin Islands' },
  { id: 'va', name: 'Virginia' },
  { id: 'wa', name: 'Washington' },
  { id: 'wv', name: 'West Virginia' },
  { id: 'wi', name: 'Wisconsin' },
  { id: 'wy', name: 'Wyoming' },
];

export const metrcVersion = [
  { id: 'v1', name: 'v1' },
  { id: 'v2', name: 'v2' },
];

export const targetTypes = [
  { is_target: true, name: 'Target & Control' },
  { is_target: false, name: 'High & Low with Control' },
];

export const UNITS_TYPES_MAP = {
  UNIVERSAL: 0,
  METRIC: 1,
  DEHUMIDIFICATION_CAPABILITY: 2,
  FILTER_CAPABILITY: 3,
  HVAC_CAPABILITY: 4,
  HUMIDIFICATION: 5,
  AIRFLOW: 6,
  OTHER: 7,
  LENGTH: 8,
  WIDTH: 9,
  HEIGHT: 10,
};

export const PLANNING = 1;
export const READY_FOR_GROW = 2;
export const ACTIVE = 3;
export const COMPLETE = 4;
export const DESTROYED = 5;
export const ARCHIVED = 6;

export const cropPlanStatusChoices = [
  { value: PLANNING, label: 'Planning', default: true },
  { value: READY_FOR_GROW, label: 'Ready For Grow' },
  { value: ACTIVE, label: 'Active' },
  { value: COMPLETE, label: 'Complete' },
  { value: DESTROYED, label: 'Destroyed' },
  { value: ARCHIVED, label: 'Archived' },
];

export const ONCE = 0;
export const DAILY = 1;
export const WEEKLY = 2;
export const CUSTOM = 3;

export const taskOccurrenceChoices = [
  { value: ONCE, label: 'Once', default: true },
  { value: DAILY, label: 'Daily' },
  { value: WEEKLY, label: 'Weekly' },
  { value: CUSTOM, label: 'Custom' },
];

export const SUNDAY = 0;
export const MONDAY = 1;
export const TUESDAY = 2;
export const WEDNESDAY = 3;
export const THURSDAY = 4;
export const FRIDAY = 5;
export const SATURDAY = 6;

export const daysOfWeek = [
  { value: SUNDAY, label: 'Sunday' },
  { value: MONDAY, label: 'Monday' },
  { value: TUESDAY, label: 'Tuesday' },
  { value: WEDNESDAY, label: 'Wednesday' },
  { value: THURSDAY, label: 'Thursday' },
  { value: FRIDAY, label: 'Friday' },
  { value: SATURDAY, label: 'Saturday' },
];

export const growthPhaseOptions = [
  { value: 'Vegetative', label: 'Vegetative' },
  { value: 'Flowering', label: 'Flowering' },
  { value: 'Harvested', label: 'Harvested' },
  { value: 'Destroyed', label: 'Destroyed' },
];

export const BATCH = 0;
export const STRAIN = 2;
export const PLANT = 1;
export const ROOM = 3;
export const NONE = 4;
export const HARVEST = 5;
export const BUCKET = 6;
export const PACKAGE = 7;

export const taskLevelOptions = [
  { value: BATCH, label: 'Batch' },
  { value: STRAIN, label: 'Strain' },
  { value: PLANT, label: 'Plant' },
  { value: ROOM, label: 'Room' },
  { value: NONE, label: 'None' },
  { value: HARVEST, label: 'Harvest' },
  { value: BUCKET, label: 'Bucket' },
  { value: PACKAGE, label: 'Package' },
];

export const newTaskValuesConstants = category => [
  {
    datatype: `bucket_category_${category?.categoryNum}_id`,
    key: `${category.name} ID`,
    value: category.id,
    isRequired: true,
    isVisible: false,
    isEditable: false,
    tempRef: `temp_${Date.now()}_bucket_id_${category.categoryNum}`,
  },
  {
    datatype: `bucket_category_${category?.categoryNum}_name`,
    key: category.name,
    value: category.name,
    isRequired: true,
    isVisible: true,
    isEditable: false,
    tempRef: `temp_${Date.now()}_bucket_name_${category.categoryNum}`,
  },
  {
    datatype: `bucket_category_${category?.categoryNum}_count`,
    key: `${category.name} Count`,
    value: 0,
    isRequired: true,
    isVisible: true,
    isEditable: true,
    tempRef: `temp_${Date.now()}_bucket_count_${category.categoryNum}`,
  },
];

export const availableCategories = [
  {
    id: 4,
    name: 'Usable',
    categoryNum: '01',
  },
  {
    id: 5,
    name: 'Trim & By-product',
    categoryNum: '02',
  },
  {
    id: 6,
    name: 'Waste',
    categoryNum: '03',
  },
];

export const taskValuesEntry = [
  {
    key: 'Harvest ID',
    datatype: 'harvest_id',
    dependent_datatype: null,
    level: 'harvest',
    isEditable: 1,
    isRequired: 1,
    isVisible: 0,
  },
  {
    key: 'Harvest Name',
    datatype: 'harvest_name',
    dependent_datatype: null,
    level: 'harvest',
    isEditable: 0,
    isRequired: 1,
    isVisible: 1,
  },
  {
    key: 'Strain ID',
    datatype: 'strain_id',
    dependent_datatype: null,
    level: 'strain',
    isEditable: 1,
    isRequired: 1,
    isVisible: 0,
  },
  {
    key: 'Strain Name',
    datatype: 'strain_name',
    dependent_datatype: null,
    level: 'strain',
    isEditable: 1,
    isRequired: 1,
    isVisible: 1,
  },
  {
    key: 'Batch ID',
    datatype: 'batch_id',
    dependent_datatype: null,
    level: 'batch',
    isEditable: 1,
    isRequired: 1,
    isVisible: 0,
  },
  {
    key: 'Batch Name',
    datatype: 'batch_name',
    dependent_datatype: null,
    level: 'batch',
    isEditable: 1,
    isRequired: 1,
    isVisible: 1,
  },
  {
    key: 'Plant ID',
    datatype: 'plant_id',
    dependent_datatype: null,
    level: 'plant',
    isEditable: 1,
    isRequired: 1,
    isVisible: 0,
  },
  {
    key: 'Plant Tag',
    datatype: 'plant_name',
    dependent_datatype: null,
    level: 'plant',
    isEditable: 1,
    isRequired: 1,
    isVisible: 1,
  },
  {
    key: 'Room ID',
    datatype: 'room_id',
    dependent_datatype: null,
    level: 'room',
    isEditable: 1,
    isRequired: 1,
    isVisible: 0,
  },
  {
    key: 'Room Name',
    datatype: 'room_name',
    dependent_datatype: null,
    level: 'room',
    isEditable: 1,
    isRequired: 1,
    isVisible: 1,
  },
];

export const taskStatus = [
  { id: 'onhold', name: 'On Hold', disabled: false },
  { id: 'pending', name: 'Pending', disabled: false },
  { id: 'open', name: 'Open', disabled: false },
  { id: 'complete', name: 'Complete', disabled: false },
  { id: 'ongoing', name: 'Ongoing', disabled: false },
  { id: 'metrc_review', name: 'Metrc Review', disabled: false },
  { id: 'metrc_validated', name: 'Metrc Validated', disabled: true },
  { id: 'metrc_synced', name: 'Metrc Synced', disabled: true },
  { id: 'archive', name: 'Archive', disabled: true },
];

export const SEED = 1;
export const CLONE = 2;

export const PLANT_TYPES = [
  { value: SEED, label: 'Seed' },
  { value: CLONE, label: 'Clone' },
];

export const localDateStringOptions = { weekday: 'short', month: 'short', day: 'numeric', year: 'numeric' };

export const defHarvestForecastTableTitlesMap = [
  { key: 'Strain', valueKey: 'strain_name' },
  { key: 'No. of Plants Harvested', valueKey: 'plants_harvest_count' },
  { key: 'Dry Flower(lbs.)', valueKey: 'dry_flower' },
  {
    key: 'Flower Price Point',
    valueKey: 'flower_price_point',
    toFormat: true,
    valueFunc: val => `$${Number.parseFloat(val?.flower_price_point).toLocaleString()}`,
  },
  {
    key: 'Total Flower Value',
    valueKey: 'total_flower_value',
    toFormat: true,
    valueFunc: val => `$${Number.parseFloat(val?.total_flower_value).toLocaleString()}`,
  },
];

export const FIRST_MINICARD_TITLE = 0; // Days FGI
export const SECOND_MINICARD_TITLE = 1; // Harvest Count
export const THIRD_MINICARD_TITLE = 2; // Price FP
export const FOURTH_MINICARD_TITLE = 3; // Serial Cnt

export const FIRST_MEGACARD_TITLE = 0; // Flower Yield
export const SECOND_MEGACARD_TITLE = 1; // Total Dry Flower
export const THIRD_MEGACARD_TITLE = 2; // Overall Harvest
export const FOURTH_MEGACARD_TITLE = 3; // Dry Flower per Light

export const MINI_CARD_0 = 'MINI_CARD_0';
export const MINI_CARD_1 = 'MINI_CARD_1';
export const MINI_CARD_2 = 'MINI_CARD_2';
export const MINI_CARD_3 = 'MINI_CARD_3';

export const MEGA_CARD_0 = 'MEGA_CARD_0';
export const MEGA_CARD_1 = 'MEGA_CARD_1';
export const MEGA_CARD_2 = 'MEGA_CARD_2';
export const MEGA_CARD_3 = 'MEGA_CARD_3';

export const PLAN_CARD_TITLE_COUNT = 12;
export const PLAN_CARD_CHAR_COUNT = 20;

// Codes

// ? - Should all create constants be unique

export const FARM_WIZARD_TYPE = 'farmWizardSteps';

export const FARM_WIZARD = {
  ROOM_CREATE: 3,
};

export const PLAN_WIZARD_TYPE = 'planWizardSteps';

export const PLAN_WIZARD = {
  PHASEPLAN_CREATE: 0,
  METRICPLAN_CREATE: 1,
  QUALITYPLAN_CREATE: 2,
  GROWPLAN_CREATE: 3,
  CROPPLAN_CREATE: 4,
};

// Classes
export const addEntityCardClasses = {
  button: 'add-entity-card-button',
  icon: 'add-entity-card-icon',
  typo: 'add-entity-card-typo',
};

export const baseClasses = {
  baseEntityCardBox: 'base-entity-card-box',
  chart: {
    svg: 'base-chart-svg',
    innerWrapper: 'base-chart-inner-wrapper-g',
    plotArea: 'base-chart-plot-area-g',
    xAxis: 'base-chart-x-axis-g',
    yAxis: 'base-chart-y-axis-g',
  },
  orgSetupOutline: {
    // imageBox: 'org-setup-outline-image-box',
    box: 'org-setup-outline-box',
    contentBox: 'org-setup-outline-content-box',
    logoBox: 'org-setup-outline-logo-box',
    logoImageBox: 'org-setup-outline-logo-image-box',
    logoImage: 'org-setup-outline-logo-image',
    brandTypo: 'org-setup-outline-brand-typo',
  },
  setupOutlinePage: {
    box: 'setup-outline-page-box',
    bgImgBox: 'setup-outline-page-bg-image-box',
    bgImage: 'setup-outline-page-bg-image',
    contentBox: 'setup-outline-page-content-box',
    logoBox: 'setup-outline-page-logo-box',
    logoImageBox: 'setup-outline-page-logo-image-box',
    brandTypo: 'setup-outline-page-brand-typo',
    hideImage: 'setup-outline-page-hide-image',
    allowAddFarm: 'setup-outline-page-allow-add-farm',
  },
  wrapper: 'base-wrapper',
};

export const baseNewAndDetailClasses = {
  box: 'base-new-and-detail-box',
  headerBox: 'base-new-and-detail-header-box',
  titleBox: 'base-new-and-detail-title-box',
  titleTypo: 'base-new-and-detail-title-typo',
  breadcrumbSepIcon: 'base-new-and-detail-breadcrumb-sep-icon',
  breadcrumbs: 'base-new-and-detail-breadcrumbs',
  breadcrumbLinkTypo: 'base-new-and-detail-breadcrumb-link-typo',
  tab: 'base-new-and-detail-tab',
  circularProgress: 'base-new-and-detail-circular-progress',
  saveBtn: 'base-new-and-detail-save-button',
  createBtn: 'base-new-and-detail-create-button',
  tabs: 'base-new-and-detail-tabs',
  divider: 'base-new-and-detail-divider',
};

export const cardClasses = {
  cropLink: {
    box: 'crop-link-card-box',
    titleBox: 'crop-link-card-title-box',
    titleKeyTypo: 'crop-link-card-title-key-typo',
    titleValueTypo: 'crop-link-card-title-value-typo',
    link: 'crop-link-card-link',
    linkBtn: 'crop-link-card-link-button',
    linkIcon: 'crop-link-card-link-icon',
  },
  cropRun: {
    box: 'crop-run-card-box',
    headerBox: 'crop-run-card-header-box',
    dateTypo: 'crop-run-card-date-typo',
    statusTypo: 'crop-run-card-status-typo',
    titleTypo: 'crop-run-card-title-typo',
    descTypo: 'crop-run-card-desc-typo',
  },
  cropSpec: {
    box: 'crop-spec-card-box',
    icon: 'crop-spec-card-icon',
    titleTypo: 'crop-spec-card-title-typo',
    valueTypo: 'crop-spec-card-value-typo',
  },
  detailAccordion: {
    accordion: 'detail-accordion-accordion',
    accordionSummary: 'detail-accordion-accordion-summary',
    titleBox: 'detail-accordion-title-box',
    titleTypo: 'detail-accordion-title-typo',
    titleCropIcon: 'detail-accordion-title-crop-icon',
    titleQPTypo: 'detail-accordion-title-qp-typo',
    titleActionBox: 'detail-accordion-title-action-box',
    actionBtnIcon: 'detail-accordion-action-button-icon',
    seeMoreIcon: 'detail-accordion-see-more-icon',
    actionEditBtn: 'detail-accordion-action-edit-button',
    actionUnlinkBtn: 'detail-accordion-action-unlink-button',
    actionSeeCloseBtn: 'detail-accordion-action-see-close-button',
    detailBox: 'detail-accordion-detail-box',
    detailEntryBox: 'detail-accordion-detail-entry-box',
    detailEntryKeyTypo: 'detail-accordion-detail-entry-key-typo',
    detailEntryValueTypo: 'detail-accordion-detail-entry-value-typo',
  },
  detailInfo: {
    paper: 'detail-info-card-paper',
    titlePaper: 'detail-info-card-title-paper',
    titleTypo: 'detail-info-card-title-typo',
    editIcon: 'detail-info-card-edit-icon',
    editButton: 'detail-info-card-edit-button',
    entryTypo: 'detail-info-card-entry-typo',
    entriesBox: 'detail-info-card-entries-box',
  },
  drag: {
    box: 'drag-card-box',
    icon: 'drag-card-icon',
    typo: 'drag-card-typo',
  },
  dragAccordion: {
    accordion: 'drag-accordion-card-accordion',
    accordionSummary: 'drag-accordion-card-accordion-summary',
    box: 'drag-accordion-card-box',
    titleBox: 'drag-accordion-card-title-box',
    icon: 'drag-accordion-card-icon',
    typo: 'drag-accordion-card-typo',
    seeMoreBtn: 'drag-accordion-card-see-more-button',
    seeMoreIcon: 'drag-accordion-card-see-more-icon',
    contentBox: 'drag-accordion-card-content-box',
    expanded: 'drag-accordion-card-expanded',
  },
  expand: {
    accordion: 'expand-card-accordion',
    accordionSummary: 'expand-card-accordion-summary',
    titleBox: 'expand-card-title-box',
    titleTypo: 'expand-card-title-typo',
    titleCropIcon: 'expand-card-title-crop-icon',
    titleQPTypo: 'expand-card-title-qp-typo',
    actionBox: 'expand-card-action-box',
    actionBtnIcon: 'expand-card-action-button-icon',
    seeMoreIcon: 'expand-card-see-more-icon',
    actionBtn: 'expand-card-action-button',
    actionSeeCloseBtn: 'expand-card-action-see-close-button',
    detailBox: 'expand-card-detail-box',
    detailEntryBox: 'expand-card-detail-entry-box',
    detailEntryKeyTypo: 'expand-card-detail-entry-key-typo',
    detailEntryValueTypo: 'expand-card-detail-entry-value-typo',
    expandedState: 'expand-card-expanded-state',
  },
  externalCard: {
    box: 'external-card-box',
    logoImage: 'external-card-logo-image',
  },
  farm: {
    paper: 'farm-card-paper',
    icon: 'farm-card-icon',
    nameTypo: 'farm-card-name-typo',
    countTypo: 'farm-card-count-typo',
    roomIcon: 'farm-card-room-icon',
  },
  farmRoomDetail: {
    paper: 'farm-room-detail-card-paper',
    upperInfoBox: 'farm-room-detail-card-upper-info-box',
    icon: 'farm-room-detail-card-icon',
    nameTypo: 'farm-room-detail-card-name-typo',
    mappingTypo: 'farm-room-detail-card-mapping-typo',
    mappingIcon: 'farm-room-detail-card-mapping-icon',
    lowerInfoBox: 'farm-room-detail-card-lower-info-box',
    sizeTypo: 'farm-room-detail-card-size-typo',
    sizeIcon: 'farm-room-detail-card-size-icon',
    lightsTypo: 'farm-room-detail-card-lights-typo',
    lightsIcon: 'farm-room-detail-card-lights-icon',
    sensorsTypo: 'farm-room-detail-card-sensors-typo',
    sensorsIcon: 'farm-room-detail-card-sensors-icon',
  },
  inProdInv: {
    box: 'in-production-inv-card-box',
    valueTypo: 'in-production-inv-card-value-typo',
    titleTypo: 'in-production-inv-card-title-typo',
    footerBox: 'in-production-inv-card-footer-box',
    expTypo: 'in-production-inv-card-exp-typo',
    actualsTypo: 'in-production-inv-card-actuals-typo',
    icon: 'in-production-inv-card-icon',
  },
  metrcRoomDragCard: {
    box: 'metrc-room-drag-card-box',
    icon: 'metrc-room-drag-card-icon',
    typo: 'metrc-room-drag-card-typo',
  },
  plan: {
    box: 'plan-card-box',
    headerBox: 'plan-card-header-box',
    icon: 'plan-card-icon',
    labelTypo: 'plan-card-label-typo',
    titleTypo: 'plan-card-title-typo',
    descTypo: 'plan-card-desc-typo',
  },
  plansDetailInfo: {
    box: 'plans-detail-info-card-box',
    headerBox: 'plans-detail-info-card-header-box',
    headerTypo: 'plans-detail-info-card-header-typo',
    editIcon: 'plans-detail-info-card-edit-icon',
    editBtn: 'plans-detail-info-card-edit-button',
    contentBox: 'plans-detail-info-card-content-box',
    entryBox: 'plans-detail-info-card-entry-box',
    entryKeyTypo: 'plans-detail-info-card-entry-key-typo',
    entryValueTypo: 'plans-detail-info-card-entry-value-typo',
    entryValueIcon: 'plans-detail-info-card-entry-icon',
  },
  room: {
    paper: 'room-card-paper',
    icon: 'room-card-icon',
    nameTypo: 'room-card-name-typo',
    mappingTypo: 'room-card-mapping-typo',
    mappingIcon: 'room-card-mapping-icon',
  },
  roomDetailInfoCard: {
    cardPaper: 'room-detail-info-card-paper',
    cardTitlePaper: 'room-detail-info-card-title-paper',
    cardTitleTypo: 'room-detail-info-card-title-typo',
    cardEditIcon: 'room-detail-info-card-edit-icon',
    cardEditBtn: 'room-detail-info-card-edit-button',
    cardEntryTypo: 'room-detail-info-card-entry-typo',
  },
  roomDetailItemInfoCard: {
    paper: 'room-detail-item-info-card-paper',
  },
  strainAccordion: {
    accordion: 'strain-accordion-accordion',
    accordionExpandIcon: 'strain-accordion-expand-icon',
    accordionSummary: 'strain-accordion-accordion-summary',
    tableHead: 'strain-table-header',
    tableTitleCell: 'strain-table-title-cell',
    textField: 'strain-textfield',
  },
};

export const metrcClasses = {
  metrc: {
    paper: 'metrc-card-paper',
    icon: 'metrc-card-icon',
    nameTypo: 'metrc-card-name-typo',
    countTypo: 'metrc-card-count-typo',
    roomIcon: 'metrc-card-room-icon',
  },
};

export const chartClasses = {
  progressRing: {
    svg: 'progress-ring-svg',
    innerWrapper: 'progress-ring-inner-wrapper',
    plotArea: 'progress-ring-plot-area',
    completionRing: 'progress-ring-completion-ring',
    title: 'progress-ring-title',
    value: 'progress-ring-value',
  },
  timeline: {
    box: 'timeline-chart-box',
    titleBox: 'timeline-chart-title-box',
    gridEntriesBox: 'timeline-chart-grid-entries-box',
    rowHeaderBox: 'timeline-chart-row-header-box',
    rowContentBox: 'timeline-chart-row-content-box',
    valueBox: 'timeline-chart-value-box',
  },
};

export const compClasses = {
  detailAndDelBtn: {
    paper: 'detail-and-del-btn-paper',
    detailIcon: 'detail-and-del-btn-detail-icon',
    delIcon: 'detail-and-del-btn-delete-icon',
  },
  subPhaseEntry: {
    box: 'sub-phase-entry-box',
    typo: 'sub-phase-entry-typo',
    textInfoIcon: 'sub-phase-entry-text-info-icon',
    textField: 'sub-phase-entry-textfield',
    checkbox: 'sub-phase-entry-checkbox',
    disabled: 'sub-phase-entry-disabled',
  },
};

export const cropClasses = {
  box: 'crop-box',
  specificsstack: 'crop-stack-container',
  headerBox: 'crop-header-box',
  titleBox: 'crop-header-title-box',
  titleTypo: 'crop-header-title-typo',
  breadcrumbSepIcon: 'crop-header-breadcrumbs-sep-icon',
  breadcrumbs: 'crop-header-breadcrumbs',
  breadcrumbLinkTypo: 'crop-header-breadcrumbs-link-typo',
  saveBtn: 'crop-save-button',
  tabs: 'crop-tabs',
  tab: 'crop-tab',
  divider: 'crop-divider',
  textField: 'crop-textfield',
  overviewBox: 'crop-overview-box',
  overviewDetailBox: 'crop-overview-detail-box',
  overviewGridEntryBox: 'crop-overview-grid-entry-box',
  overviewGridEntryOuterBox: 'crop-overview-grid-entry-outer-box',
  overviewGridEntryTitleBox: 'crop-overview-grid-entry-title-box',
  overviewTitlePhaseBox: 'crop-overview-title-phase-box',
  overviewFooterBox: 'overview-footer-box',
  overviewFooterSpecCardBox: 'overview-footer-spec-card-box',
  overviewFooterSpecsContentBox: 'overview-footer-specs-content-box',
  overviewFooterSpecsTypo: 'overview-footer-specs-typo',
  overviewFooterSpecsListBox: 'overview-footer-specs-list-box',
  overviewFooterLinksContentBox: 'overview-footer-links-content-box',
  overviewFooterLinksTypo: 'overview-footer-links-typo',
  overviewFooterLinksListBox: 'overview-footer-links-list-box',
  overviewFooterLinkCardBox: 'overview-footer-link-card-box',
  overviewAccordion: 'overview-accordion',
  overviewDivider: 'overview-divider',
  overviewArrowIcon: 'overview-down-arrow-icon',
  overviewAccordionDetails: 'overview-accordion-details',
  overviewKeyTypo: 'overview-key-typo',
  overviewTextField: 'crop-overview-textfield',
  expandedARContentBox: 'timeline-chart-expanded-alert-routine-content-box',
  expandedDayBox: 'timeline-chart-expanded-day-box',
  todayDayEntry: 'timeline-chart-today-day-entry',
  expandedARContentIcon: 'timeline-chart-expanded-alert-routine-content-icon',
  expandedARContentTypoBox: 'timeline-chart-expanded-alert-routine-content-typo-box',
  expandedARSeeDetailBtn: 'timeline-chart-expanded-alert-routine-see-detail-button',
  expandedWeekContentBox: 'timeline-chart-expanded-week-content-box',
  expandedWeekARBox: 'timeline-chart-expanded-week-alert-routine-box',
  expandedWeekAlertIcon: 'timeline-chart-expanded-week-alert-icon',
  expandedMetricPlanContentBox: 'timeline-chart-expanded-metricplan-content-box',
  expandedMetricPlanBox: 'timeline-chart-expanded-metricplan-box',
  expandedWeekRoutineIcon: 'timeline-chart-expanded-week-routine-icon',
  expandedGridEntryDayBox: 'timeline-chart-expanded-grid-entry-day-box',
  expandedGridEntrySubPhaseBox: 'timeline-chart-expanded-grid-entry-subphase-box',
  selectedTimelineWeekHeader: 'timeline-chart-week-header-selected',
  metricPlanTitleEntry: 'metricplan-title-entry',
  subPhaseEntry: 'timeline-chart-subphase-entry',
  subPhaseEntryTypo: 'timeline-chart-subphase-entry-typo',
  dayEntry: 'timeline-chart-day-entry',
  highlightMP: 'timeline-chart-highlight-metricplan',
  specificsBox: 'crop-specifics-box',
  specificsTitleTypo: 'crop-specifics-title-typo',
  growplanMenuItem: 'crop-specifics-growplan-menuitem',
  menuItem: 'crop-specifics-status-menuitem',
  growplanMenuFocus: 'crop-specifics-growplan-menuitem-focus',
  statusMenuFocus: 'crop-specifics-status-menuitem-focus',
  phases: {
    phasesBox: 'crop-phases-box',
    strainTab: 'crop-phases-strain-tab',
    phaseTab: 'crop-phases-phase-tab',
    strainContainer: 'crop-phases-strain-box',
  },
};

// 06-04-2023: Below is currently in use
export const cropsClasses = {
  saveBtn: 'crops-save-button',
  tabs: 'crops-tabs',
  runsBox: 'crops-cropruns-box',
  plansBox: 'crops-cropplans-box',
  historyBox: 'crops-crophistory-box',
  entityCardBox: 'crops-entity-card-box',
  entityCardDescTypo: 'crops-entity-card-desc-typo',
  cropsCardExtraTypo: 'crops-crops-card-extra-typo',
};

export const cropRunClasses = {
  box: 'crop-run-box',
  titleBox: 'crop-run-title-box',
  titleTypo: 'crop-run-title-typo',
  tabs: 'crop-run-tabs',
  tab: 'crop-run-tab',
  divider: 'crop-run-divider',
  contentBox: 'crop-run-content-box',
};

export const dashdrawerClasses = {
  accListBtn: 'dashdrawer-listbutton', // not actually an accordion list button; but this button in inside an accordion; hence the name;
  accListIcon: 'dashdrawer-listicon',
  accListItem: 'dashdrawer-listitem',
  accListText: 'dashdrawer-listtext',

  dashAccDetails: 'dashdrawer-acc-details',
  dashAccordion: 'dashdrawer-accordion',
  dashAccSummary: 'dashdrawer-acc-summary',
  dashAvatar: 'dashdrawer-avatar',
  dashAvatarTypo: 'dashdrawer-avatar-typo',
  dashFooterPaper: 'dashdrawer-footer-paper',
  dashFooterDivider: 'dashdrawer-footer-divider',
  dashIcon: 'dashdrawer-dash-icon',
  dashLoginTypo: 'dashdrawer-login-typo',
  dashLogoPaper: 'dashdrawer-logo-paper',
  dashLogoBox: 'dashdrawer-logo-box',
  dashLogoImg: 'dashdrawer-logo-image',
  dashLogoTypo: 'dashdrawer-logo-typo',
  dashMenuPaper: 'dashdrawer-menu-paper',
  dashProfilePaper: 'dashdrawer-profile-paper',
  dashRoleTypo: 'dashdrawer-role-typo',
  drawer: 'dashdrawer-drawer',
  drawerClosed: 'dashdrawer-closed',

  listItem: 'dashdrawer-listitem',
  listItemBtn: 'dashdrawer-listitembutton',
  listItemIcon: 'dashdrawer-listitemicon',
  listItemText: 'dashdrawer-listitemtext',

  tabSelected: 'dashdrawer-tabselected',
};

export const dashboardClasses = {
  bedTimeIcon: 'dashboard-bedtime-icon',
  divider: 'dashboard-divider',
  dateInfoTypo: 'dashboard-date-info-typo',
  outerEndBox: 'dashboard-outer-end-box',
  outerEndBoxExpanded: 'dashboard-outer-end-box-expanded',
  // outerEndBox: 'dashboard-outer-end-box',
  endBox: 'dashboard-end-box',
  endBoxExpanded: 'dashboard-end-box-expanded',
  endBoxBase: 'dashboard-end-box-base',
  goBackIcon: 'dashboard-go-back-icon',
  greetingBox: 'dashboard-greeting-box',
  greetingSubTitleTypo: 'dashboard-greeting-sub-title-typo',
  greetingTitleTypo: 'dashboard-greeting-title-typo',
  innerScrollBox: 'dashboard-inner-scroll-box',
  middleBox: 'dashboard-middle-box',
  middleBoxCollapse: 'dashboard-middle-box-collapse',
  megaCardsBox: 'dashboard-mega-cards-box',
  megaCardsFrameBox: 'dashboard-mega-cards-frame-box',
  megaCardsFrameFooterBtn: 'dashboard-mega-cards-frame-footer-button',
  megaCardsFrameHeaderTypo: 'dashboard-mega-cards-frame-header-typo',
  miniCardsBox: 'dashboard-mini-cards-box',
  miniCardsFrameBox: 'dashboard-mini-cards-frame-box',
  miniCardsFrameFooterBtn: 'dashboard-mini-cards-frame-footer-button',
  miniCardsFrameHeaderTypo: 'dashboard-mini-cards-frame-header-typo',
  plantBox: 'dashboard-plant-box',
  plantInnerBox: 'dashboard-plant-inner-box',
  plantPotIcon: 'dashboard-plant-pot-icon',
  projectionsInfoBox: 'dashboard-projections-info-box',
  projectionsInfoBoxExpanded: 'dashboard-projections-info-box-expanded',
  projectionsBox: 'dashboard-projections-box',
  projectionsEntryBox: 'dashboard-projections-entry-box',
  projectionsEntryTitleTypo: 'dashboard-projections-entry-title-typo',
  projectionsEntryValueTypo: 'dashboard-projections-entry-value-typo',
  projectionsTypo: 'dashboard-projections-typo',
  projectionsTypoBox: 'dashboard-projections-typo-box',
  seeDetailBtn: 'dashboard-see-detail-button',
  seeDetailIcon: 'dashboard-see-detail-icon',
  sgDashIcon: 'dashboard-smartgrow-icon',
  sunnyDayIcon: 'dashboard-sunny-day-icon',
  wrapperBox: 'dashboard-wrapper-box',
  inProdInv: {
    box: 'dashboard-inproductioninv-box',
    logoBox: 'dashboard-inproductioninv-logo-box',
    logoBtnBox: 'dashboard-inproductioninv-logo-button-box',
    logoIcon: 'dashboard-inproductioninv-logo-icon',
    backIcon: 'dashboard-inproductioninv-back-icon',
    backBtn: 'dashboard-inproductioninv-back-button',
    titleTypo: 'dashboard-inproductioninv-title-typo',
    cardsBox: 'dashboard-inproductioninv-cards-box',
    tablesBox: 'dashboard-inproductioninv-tables-box',
  },

  projectionsExpanded: 'dashboard-projections-expanded', // can be applied to any component when values.projectionExpanded changes, then use this class to style that component
};

export const dashMegaCardClasses = {
  box: 'dash-mega-card-box',
  otherIcon: 'dash-mega-card-other-icon',
  icon: 'dash-mega-card-icon',
  seeMoreBtn: 'dash-mega-card-see-more-button',
  titleTypo: 'dash-mega-card-title-typo',
  descTypo: 'dash-mega-card-desc-typo',
  valueTypo: 'dash-mega-card-value-typo',
};

export const dashMiniCardClasses = {
  box: 'dash-mini-card-box',
  otherIcon: 'dash-mini-card-other-icon',
  icon: 'dash-mini-card-icon',
  seeMoreBtn: 'dash-mini-card-see-more-button',
  titleTypo: 'dash-mini-card-title-typo',
  descTypo: 'dash-mini-card-desc-typo',
  valueTypo: 'dash-mini-card-value-typo',
};

export const externalDetailClasses = {
  box: 'external-detail-box',
  tabTitleTypo: 'external-detail-tab-title-typo',
  tabContentTypo: 'external-detail-tab-content-typo',
  tabContentLinkTypo: 'external-detail-tab-content-link-typo',
};

export const fabsClasses = {
  prevNext: {
    fab: 'prev-next-fab-fab',
    prevStepBox: 'prev-next-fab-prev-step-box',
    prevStep: 'prev-next-fab-prev-step',
    nextStepBox: 'prev-next-fab-next-step-box',
    nextStep: 'prev-next-fab-next-step',
    singleStep: 'prev-next-fab-single-step',
    disabledStep: 'prev-next-fab-disabled-step',
  },
};

export const farmDetailClasses = {
  paper: 'farm-detail-paper',
  headerBox: 'farm-detail-header-box',
  titleBox: 'farm-detail-title-box',
  nameTypo: 'farm-detail-name-typo',
  breadcrumbLinkTypo: 'farm-detail-breadcrumb-link-typo',
  createRoomBtn: 'farm-detail-create-room-button',
  roomsTypo: 'farm-detail-rooms-typo',
  roomsPaper: 'farm-detail-rooms-paper',
  noRoomTypo: 'farm-detail-no-room-typo',
  breadcrumbSepIcon: 'farm-detail-breadcrumb-sep-icon',
  breadcrumb: 'farm-detail-breadcrumb',
  noEntity: 'farm-detail-noentity',
};

export const farmsClasses = {
  icon: 'farms-icon',
  paper: 'farms-paper',
  orgPaper: 'farms-org-paper',
  orgTitleTypo: 'farms-org-title-typo',
  orgNameTypo: 'farms-org-name-typo',
  titleTypo: 'farms-title-typo',
  keyTypo: 'farms-key-typo',
  keyRefreshAddPaper: 'farms-key-refresh-add-paper',
  keySelect: 'farms-key-select',
  refreshBtn: 'farms-refresh-button',
  addFarmBtn: 'farms-add-farm-button',
  keyMenuItem: 'farms-key-menuitem',
  tabs: 'farms-tabs',
  tab: 'farms-tab',
  divider: 'farms-divider',
  noEntityTypo: 'farms-no-entity-typo',
  listPaper: 'farms-list-paper',
  tableListPaper: 'farms-table-list-paper',
};

export const metrcTagsClasses = {
  tableListPaper: 'metrc-tags-table-paper',
  tableBox: 'metrc-tags-tables-box',
  filterTitleTypo: 'room-detail-filter-typo',
  chip: 'metrc-tag-chip',
};

export const feedbackClasses = {
  downloadingMetrcDataMsg: {
    box: 'download-metrc-data-msg-box',
    downloadBox: 'download-metrc-data-msg-download-box',
    titleTypo: 'download-metrc-data-msg-title-typo',
    timeTypo: 'download-metrc-data-msg-time-typo',
  },
  taskStatusSnackbar: {
    actionBtn: 'task-status-snackbar-action-button',
    snackbar: 'task-status-snackbar-snackbar',
    alert: 'task-status-snackbar-alert',
  },
};

export const invitePageClasses = {
  contentBox: 'invite-page-content-box',
  userIcon: 'invite-page-user-icon',
  welTypo: 'invite-page-wel-typo',
  welSubTypo: 'invite-page-wel-sub-typo',
  formBox: 'invite-page-form-box',
  textField: 'invite-page-textfield',
  visibilityIcon: 'invite-page-visibility-icon',
  instructionBox: 'invite-page-instruction-box',
  instructionTypo: 'invite-page-instruction-typo',
  submitBtn: 'invite-page-submit-button',
};

export const landingPageClasses = {
  box: 'landing-page-box',
  navBox: 'landing-page-nav-box',
  contentBox: 'landing-page-content-box',
  navTitleTypo: 'landing-page-nav-title-typo',
  navAccessBtn: 'landing-page-nav-access-button',
  headlineTypo: 'landing-page-headline-typo',
  descTypo: 'landing-page-desc-typo',
  accessBtn: 'landing-page-access-button',
  bgImageBox: 'landing-page-bg-image-box',
  loginBtn: 'landing-page-login-button',
};

export const metricPlanCardClasses = {
  paperWrapper: 'metric-plan-container',
  card: 'metric-plan-card-wrapper',
  titleTypo: 'metric-plan-card-title-typo',
  subHeaderTypo: 'metric-plan-card-sub-header-typo',
  linkIcon: 'metric-plan-link-icon',
  cardActions: 'metric-plan-card-actions',
  button: 'metric-plan-card-btn',
  delBtn: 'metric-plan-del-btn',
};

export const forecastPopupDescClass = 'forecast-popup-desc';
export const forecastPopupStatBoxClass = 'forecast-popup-stat-box';
export const forecastPopupStatKeyClass = 'forecast-popup-stat-key';
export const forecastPopupTitleClass = 'forecast-popup-title';
export const forecastPopupStatValueClass = 'forecast-popup-stat-value';

export const growplanClasses = {
  paper: 'growplan-paper',
  headerPaper: 'growplan-header-paper',
  titlePaper: 'growplan-title-paper',
  titleTypo: 'growplan-title-typo',
  breadcrumbLinkTypo: 'growplan-breadcrumb-link-typo',
  progress: 'growplan-progress',
  saveBtn: 'growplan-save-button',
  tabs: 'growplan-tabs',
  tab: 'growplan-tab',
  divider: 'growplan-divider',
  overviewBox: 'growplan-overview-box',
  overviewInfoIcon: 'growplan-overview-info-icon',
  overviewInfoRoomIcon: 'growplan-overview-inforoom-icon',
  overviewInfoTypo: 'growplan-overview-info-typo',
  overviewSensorCountTypo: 'growplan-overview-sensor-count-typo',
  phasePlanLinkIcon: 'growplan-phaseplan-link-icon',
  qualityPlanLinkIcon: 'growplan-qualityplan-link-icon',
  overviewLeftBox: 'growplan-overview-left-box',
  overviewLeftInnerBox: 'growplan-overview-left-inner-box',
  overviewRightBox: 'growplan-overview-right-box',
  overviewDescTypo: 'growplan-overview-desc-typo',
  extLinkIcon: 'growplan-ext-link-icon',
  genInfoPaper: 'growplan-geninfo-paper',
  genInfoTitleTypo: 'growplan-geninfo-title-typo',
  planCompatibleBox: 'growplan-geninfo-plan-compatible-box',
  planCompatibleErrorIcon: 'growplan-geninfo-plan-compatible-error-icon',
  sensorCountBox: 'growplan-sensor-count-box',
  roomMenuItem: 'growplan-room-menuitem',
  menuMsgBox: 'growplan-room-menuitem-message-box',
  genInfoTextField: 'growplan-geninfo-textfield',
  phaseEntryDateBox: 'growplan-phaseplan-entry-date-box',
  phasePlanMenuItem: 'growplan-phaseplan-menuitem',
  medProfileMenuItem: 'growplan-medium-profile-menuitem',
  qualPlanMenuItem: 'growplan-qualityplan-menuitem',
  qualMenuTypoBox: 'growplan-qualityplan-menu-typo-box',
  genInfoStrainsBox: 'growplan-strains-box',
  genInfoStrainTitleBox: 'growplan-strain-title-box',
  genInfoStrainTitleTypo: 'growplan-strain-title-typo',
  genInfoStrainTableBtn: 'growplan-strain-table-button',
  genInfoStrainTablePaper: 'growplan-strain-table-paper',
  cropsBox: 'growplan-crops-box',
  cropsTitleBox: 'growplan-crops-title-box',
  // cropsEmptyTitleTypo: 'growplan-crops-emptytitle-typo',
  cropsTitleTypo: 'growplan-crops-title-typo',
  cropsTablePaper: 'growplan-crops-table-paper',
  breadcrumbSepIcon: 'growplan-breadcrumb-sep-icon',
  breadcrumbs: 'growplan-breadcrumbs',
  disabled: 'growplan-disabled',
};

export const loginPageClasses = {
  box: 'login-page-box',
  infoTypo: 'login-page-info-typo',
  actionTypo: 'login-page-action-typo',
  textField: 'login-page-textfield',
  proceedBtn: 'login-page-proceed-button',
};

export const metricPlanClasses = {
  icon: 'metric-plan-detail-icon',
  box: 'metric-plan-detail-box',
  headerBox: 'metric-plan-detail-header-box',
  titleAndNavBox: 'metric-plan-detail-title-and-nav-box',
  titleTypo: 'metric-plan-detail-title-typo',
  breadcrumbSepIcon: 'metric-plan-detail-breadcrumb-sep-icon',
  breadcrumbs: 'metric-plan-detail-breadcrumbs',
  breadcrumbLinkTypo: 'metric-plan-detail-breadcrumb-link-typo',
  button: 'metric-plan-detail-button',
  buttonIcon: 'metric-plan-detail-button-icon',
  progress: 'metric-plan-detail-progress',
  saveBtn: 'metric-plan-detail-save-button',
  wizardBtnBox: 'metric-plan-detail-wizard-btn-box',
  wizardBackBtnBox: 'metric-plan-detail-wizard-back-btn-box',
  wizardBackBtn: 'metric-plan-detail-wizard-back-button',
  saveMetricCycleBtn: 'metric-plan-detail-save-metric-cycle-button',
  tabs: 'metric-plan-detail-tabs',
  tab: 'metric-plan-detail-tab',
  divider: 'metric-plan-detail-divider',
  subPhaseDivider: 'metric-plan-subphase-divider',
  runDivider: 'metric-run-run-divider',
  textField: 'metric-plan-detail-textfield',
  stDayTextField: 'metric-run-day-textfield',
  phasePlanLinkIcon: 'metric-plan-detail-phaseplan-link-icon',
  phasePlanLinkBox: 'metric-plan-detail-phaseplan-link-box',
  overviewBox: 'metric-plan-detail-overview-box',
  leftBox: 'metric-plan-detail-left-box',
  rightBox: 'metric-plan-detail-right-box',
  cardBox: 'metric-plan-detail-card-box',
  cardHeaderBox: 'metric-plan-detail-card-header-box',
  cardHeaderTypo: 'metric-plan-detail-card-header-typo',
  attachMetricCycleEditIcon: 'metric-plan-detail-attach-metric-cycle-edit-icon',
  cardHeaderEditBtn: 'metric-plan-detail-card-header-edit-button',
  contentBox: 'metric-plan-detail-content-box',
  genInfoBox: 'metric-plan-detail-gen-info-box',
  tabTitleTypo: 'metric-plan-detail-tab-title-typo',
  tabSubTypo: 'metric-plan-detail-tab-sub-typo',
  menuItem: 'metric-plan-detail-menuitem',
  cycleTableBox: 'metric-plan-detail-cycle-table-box',
  saveChangeTypo: 'metric-plan-detail-save-change-typo',
  cycleTypeTypo: 'metric-plan-detail-cycle-type-typo',
  metricCycleTableBox: 'metric-plan-detail-metric-cycle-table-box',
  highchartsBox: 'metric-plan-detail-highcharts-box',
  noChart: 'metric-plan-detail-no-chart',
  subPhaseTypo: 'metric-plan-subphase-typo',
  metricRunBox: 'metric-plan-metricrun-box',
  metricRunIndex: 'metric-run-index-chip',
  metricRunTitleTypo: 'metric-run-title-typo',
  metricRunCardContent: 'metric-run-card-content-wrapper',
  diminishedGradient: 'dim-linear-gradient-divider',
  metricRunPaperWrapper: 'metric-run-paper-wrapper',
  metricCard: 'metric-run-card-wrapper',
  nightDivider: 'metric-run-night-divider',
  dayDivider: 'metric-run-day-divider',
  metricBaseTextField: 'metric-base-textfield',
  daypartsIcon: 'metric-run-dayparts-icon',
};

export const miscClasses = {
  alertAndRoutineBox: 'alert-and-routine-box',
  disabled: 'disabled',
  expanded: 'expanded',
  noEntityAvailable: 'no-entity-available',
  noEntityCreateButton: 'no-entity-create-button',
  menuItemFocusDark: 'menuitem-focus-dark',
  breadcrumb: {
    box: 'misc-breadcrumb-box',
    entryBox: 'misc-breadcrumb-entry-box',
    sepIcon: 'misc-breadcrumb-sep-icon',
  },
};

export const msgClasses = {
  accordionDetail: {
    box: 'accordion-detail-msg-box',
    titleTypo: 'accordion-detail-msg-title-typo',
    valueTypo: 'accordion-detail-msg-value-typo',
  },
  rowHeaderTypo: {
    typo: 'row-header-typo-msg-typo',
  },
};

export const orgClasses = {
  box: 'organization-box',
  navTitleBox: 'organization-nav-title-box',
  titleBox: 'organization-title-box',
  titleTypo: 'organization-title-typo',
  nameTypo: 'organization-name-typo',
  contentBox: 'organization-content-box',
  tabs: 'organization-tabs',
  tab: 'organization-tab',
  divider: 'organization-divider',
  formBox: 'organization-form-box',
  inputSectionBox: 'organization-input-section-box',
  textField: 'organization-textfield',
  saveBtn: 'organization-save-button',
  tableBox: 'organization-table-box',
  permTableBox: 'organization-perm-table-box',
  externalsTableBox: 'organization-externals-table-box',
  addBtn: 'organization-add-button',
};

export const orgSetupClasses = {
  box: 'org-setup-box',
  stepTypo: 'org-setup-step-typo',
  progressBox: 'org-setup-progress-box',
  progressElemBox: 'org-setup-progress-elem-box',
  detailTypo: 'org-setup-detail-typo',
  actionTypo: 'org-setup-action-typo',
  formBox: 'org-setup-form-box',
  whatsThisIcon: 'org-setup-whats-this-icon',
  textField: 'org-setup-textfield',
  agreeBox: 'org-setup-agree-box',
  checkbox: 'org-setup-checkbox',
  agreeTypo: 'org-setup-agree-typo',
  allowInfoBox: 'org-setup-allow-info-box',
  allowInfoIcon: 'org-setup-allow-info-icon',
  allowInfoTypo: 'org-setup-allow-info-typo',
  stateMenuItem: 'org-setup-state-menuitem',
  proceedBtn: 'org-setup-proceed-button',
  completedStep: 'org-setup-completed-step',
};

export const phasePlanClasses = {
  overviewWrapperBox: 'phase-plan-overview-wrapper-box',
  barBox: 'phase-plan-bar-box',
  barEntryBox: 'phase-plan-bar-entry-box',
  barDayTypo: 'phase-plan-bar-day-typo',
  barTypeTypo: 'phase-plan-bar-type-typo',
  overviewBox: 'phase-plan-overview-box',
  overviewLeftBox: 'phase-plan-overview-left-box',
  overviewLeftInnerBox: 'phase-plan-overview-left-inner-box',
  overviewRightBox: 'phase-plan-overview-right-box',
  overviewInfoTypo: 'phase-plan-overview-info-typo',
  overviewInfoIcon: 'phase-plan-overview-info-icon',
  textField: 'phase-plan-textfield',
  genInfoBox: 'phase-plan-gen-info-box',
  genInfoTitleTypo: 'phase-plan-gen-info-title-typo',
  subPhaseBox: 'phase-plan-sub-phase-box',
  subPhaseTitleBox: 'phase-plan-sub-phase-title-box',
  addSubPhaseIcon: 'phase-plan-add-sub-phase-icon',
  addSubPhaseBtn: 'phase-plan-add-sub-phase-button',
};

export const specificpopupClasses = {
  proceedBtn: 'specific-popup-proceed-button',
};
export const plansClasses = {
  box: 'plans-box',
  headerBox: 'plans-header-box',
  titleTypo: 'plans-title-typo',
  headerBtnBox: 'plans-header-button-box',
  backToWizardIconBox: 'plans-back-to-wizard-icon-box',
  backToWizardIcon: 'plans-back-to-wizard-icon',
  createBtn: 'plans-create-button',
  contentBox: 'plans-content-box',
  tabs: 'plans-tabs',
  tab: 'plans-tab',
  tabBox: 'plans-tab-box',
  tabCardBox: 'plans-tab-card-box',
  tabTitleTypo: 'plans-tab-title-typo',
  tabDescTypo: 'plans-tab-desc-typo',
  siteDevTypo: 'plans-site-dev-typo',
  divider: 'plans-divider',
  metricTabBox: 'plans-metric-tab-box',
  cropPlanCard: 'plans-crop-plan-card',
  growPlanCard: 'plans-grow-plan-card',
  qualPlanCard: 'plans-qual-plan-card',
  metricPlanCard: 'plans-metric-plan-card',
  phasePlanCard: 'plans-phase-plan-card',
  planCardExtraDetailTypo: 'plans-phase-plan-card-extra-detail-typo',
  metricFilterBox: 'plans-metric-filter-box',
  metricFilterTabs: 'plans-metric-filter-tabs',
  metricFilterChip: 'plans-metric-filter-chip',
  metricChipSelected: 'plans-metric-chip-selected',
};

export const popupClasses = {
  addLight: {
    textField: 'add-light-popup-textfield',
  },
  addStrainTable: {
    textField: 'add-strain-table-popup-textfield',
    menuItem: 'add-strain-table-popup-menuitem',
    selStrainsBox: 'add-strain-table-popup-sel-strains-box',
    dropdown: 'add-strain-table-popup-dropdown',
    filledInput: 'add-strain-table-popup-filledinput',
  },
  attachTable: {
    divider: 'attachtable-popup-divider',
    box: 'attachtable-popup-box',
    noTableTypo: 'attachtable-popup-notable-typo',
    createTableBtn: 'attachtable-popup-createtable-button',
    actionTitleBox: 'attachtable-popup-actiontitle-box',
    addNewTableBtn: 'attachtable-popup-addnewtable-button',
    textField: 'attachtable-popup-textfield',
    levelCountTypo: 'attachtable-popup-levelcount-typo',
    levelTableNameTypo: 'attachtable-popup-tablename-typo',
  },
  compareRoomAndQualPlan: {
    divider: 'compare-room-qualplan-divider',
    phaseTypo: 'compare-room-qualplan-phase-typo',
    commonBox: 'compare-room-qualplan-common-box',
    commonTypo: 'compare-room-qualplan-common-typo',
    missingBox: 'compare-room-qualplan-missing-box',
    missingTypo: 'compare-room-qualplan-missing-typo',
    listItemTypo: 'compare-room-qualplan-list-item-typo',
  },
  confirmationWithLoading: {
    modal: 'confirmation-loading-popup-modal',
    wrapperBox: 'confirmation-loading-popup-wrapper-box',
    contentBox: 'confirmation-loading-popup-content-box',
    titleBox: 'confirmation-loading-popup-title-box',
    titleTypo: 'confirmation-loading-popup-title-typo',
    messageBox: 'confirmation-loading-popup-message-box',
    messageTypo: 'confirmation-loading-popup-message-typo',
    actionBtnsBox: 'confirmation-loading-popup-action-buttons-box',
    declineBtn: 'confirmation-loading-popup-decline-button',
    proceedBtn: 'confirmation-loading-popup-proceed-button',
  },
  createMetricCycle: {
    textField: 'create-metric-cycle-popup-textfield',
  },
  createMetricPlan: {
    metricAndTargetTypeBox: 'create-metric-plan-popup-metric-and-target-type-box',
    menuItem: 'create-metric-plan-popup-menuitem',
    textField: 'create-metric-plan-popup-textfield',
  },
  createPermission: {
    textField: 'create-permission-textfield',
    rolesListBox: 'create-permission-roles-list-box',
    roleHeaderBox: 'create-permission-role-header-box',
    roleHeaderTypo: 'create-permission-role-header-typo',
    roleContentBox: 'create-permission-role-content-box',
    entryBox: 'create-permission-entry-box',
    slNoTypo: 'create-permission-slno-typo',
    nameTypo: 'create-permission-name-typo',
    checkbox: 'create-permission-checkbox',
  },
  createStrain: {
    textField: 'create-strain-popup-textfield',
  },
  cropEntryInDetailPage: {
    inpAdornment: 'crop-entry-in-detail-page-popup-input-adornment',
    textField: 'crop-entry-in-detail-page-popup-textfield',
    divider: 'crop-entry-in-detail-page-popup-divider',
    menuItem: 'crop-entry-in-detail-page-popup-menuitem',
    box: 'crop-entry-in-detail-page-popup-box',
    entryBox: 'crop-entry-in-detail-page-popup-entry-box',
    fixedKeyTypo: 'crop-entry-in-detail-page-popup-fixed-key-typo',
    fixedValueTypo: 'crop-entry-in-detail-page-popup-fixed-value-typo',
  },
  entityDetail: {
    modal: 'entity-detail-popup-modal',
    closeIconBox: 'entity-detail-popup-close-icon-box',
    closeIcon: 'entity-detail-popup-close-icon',
    paper: 'entity-detail-popup-paper',
    headerPaper: 'entity-detail-popup-header-paper',
    titleTypo: 'entity-detail-popup-title-typo',
    headContentPaper: 'entity-detail-popup-head-content-paper',
    headContentTypo: 'entity-detail-popup-head-content-typo',
    saveBtn: 'entity-detail-popup-save-button',
  },
  inviteUser: {
    box: 'invite-user-box',
    replayIcon: 'invite-user-replay-icon',
    textField: 'invite-user-textfield',
    roleMenuItem: 'invite-user-role-menuitem',
    permMenuItem: 'invite-user-perm-menuitem',
  },
  lightEntry: {
    textField: 'light-entry-popup-textfield',
  },
  metricCycle: {
    staticBox: 'metric-cycle-popup-static-box',
    staticKeyTypo: 'metric-cycle-popup-static-key-typo',
    staticValueTypo: 'metric-cycle-popup-static-value-typo',
    textField: 'metric-cycle-popup-textfield',
  },
  sensor: {
    textField: 'sensor-popup-textfield',
    menuItem: 'sensor-popup-menuitem',
    menuItemFocus: 'sensor-popup-menuitem-focus',
    kpiTypo: 'sensor-popup-kpi-typo',
    divider: 'sensor-popup-divider',
  },
  strainDetailInProdInv: {
    box: 'strain-detail-inprodinv-popup-box',
    closeIconBox: 'strain-detail-inprodinv-popup-close-icon-box',
    closeIcon: 'strain-detail-inprodinv-popup-close-icon',
    titleTypo: 'strain-detail-inprodinv-popup-title-typo',
    tablesBox: 'strain-detail-inprodinv-popup-tables-box',
    entryTableBox: 'strain-detail-inprodinv-popup-entry-table-box',
    entryRowTitleTypo: 'strain-detail-inprodinv-popup-entry-row-title-typo',
    entryContentTypo: 'strain-detail-inprodinv-popup-entry-content-typo',
  },
  strainEntry: {
    textField: 'strain-entry-popup-textfield',
    typo: 'strain-entry-popup-typo',
    tableTitle: 'strain-entry-table-title',
  },
  routines: {
    titleTypo: 'routines-popup-title-typo',
    typo: 'routines-popup-typo',
    tasksContainer: 'routines-popup-tasks-container',
    task: 'routines-popup-task',
    taskValuesContainer: 'routines-popup-task-value-container',
    assignee: 'routines-popup-assignee',
    textfield: 'routines-popup-textfield',
    toolboxContainer: 'routines-popup-toolbox-container',
    chip: 'routines-popup-status-chip',
  },
};

export const profileClasses = {
  box: 'profile-box',
  welcomeTypo: 'profile-welcome-typo',
  formBox: 'profile-form-box',
  formContentBox: 'profile-form-content-box',
  inputSectionBox: 'profile-input-section-box',
  sectionBox: 'profile-section-box',
  textField: 'profile-textfield',
  photoSectionBox: 'profile-photo-section-box',
  photoBox: 'profile-photo-box',
  contentFooterBox: 'profile-content-footer-box',
  roleTypo: 'profile-role-typo',
  saveBtn: 'profile-save-button',
};

export const qualPlanClasses = {
  accordionDragCardBox: 'quality-plan-accordion-drag-card-box',
  box: 'quality-plan-box',
  headerBox: 'quality-plan-header-box',
  headerTitleBox: 'quality-plan-header-title-box',
  actionTypo: 'quality-plan-action-typo',
  breadcrumbSepIcon: 'quality-plan-breadcrumbs-sep-icon',
  breadcrumbs: 'quality-plan-breadcrumbs',
  breadcrumbLinkTypo: 'quality-plan-breadcrumb-link-typo',
  saveBtn: 'quality-plan-save-button',
  tabs: 'quality-plan-tabs',
  tab: 'quality-plan-tab',
  divider: 'quality-plan-divider',
  contentBox: 'quality-plan-content-box',
  tabTextField: 'quality-plan-tab-textfield',
  overviewWrapperBox: 'quality-plan-overview-wrapper-box',
  timelineChartBox: 'quality-plan-timeline-chart-box',
  overviewBox: 'quality-plan-overview-box',
  phasePlanLinkIcon: 'quality-plan-phaseplan-link-icon',
  phasePlanLinkBox: 'quality-plan-phaseplan-link-box',
  overviewLeftBox: 'quality-plan-overview-left-box',
  overviewRightBox: 'quality-plan-overview-right-box',
  genInfoBox: 'quality-plan-gen-info-box',
  tabTitleTypo: 'quality-plan-tab-title-typo',
  tabSubTypo: 'quality-plan-tab-sub-typo',
  phaseplanMenuItem: 'quality-plan-phaseplan-menuitem',
  attachMetricPlansBox: 'quality-plan-attach-metric-plans-box',
  attachMsgTypo: 'quality-plan-attach-msg-typo',
  dragAndDropBox: 'quality-plan-drag-and-drop-box',
  dragAndDropEndBox: 'quality-plan-drag-and-drop-end-box',
  myQPTypo: 'quality-plan-my-qp-typo',
  myQPSubTypo: 'quality-plan-my-qp-sub-typo',
  attachedMetricPlansBox: 'quality-plan-attached-metric-plans-box',
  selPhaseTypo: 'quality-plan-sel-phase-typo',
  dragAndDropMiddleBox: 'quality-plan-drag-and-drop-middle-box',
  dragIcon: 'quality-plan-drag-icon',
  dragInfoTypo: 'quality-plan-drag-info-typo',
  dragAndDropStartBox: 'quality-plan-drag-and-drop-start-box',
  createdMPTypo: 'quality-plan-created-mp-typo',
  createdMPSubTypo: 'quality-plan-created-mp-sub-typo',
  createdMetricPlanBox: 'quality-plan-created-metric-plan-box',
  selected: 'quality-plan-selected',
  chartValueHover: 'quality-plan-chart-value-hover',
  chartWeekIcon: 'quality-plan-chart-week-icon',
  chartExpanded: 'quality-plan-chart-expanded',
};

export const roomClasses = {
  breadcrumbLinkTypo: 'room-breadcrumb-link-typo',
  saveBtn: 'room-save-button',
  tabs: 'room-tabs',
  tabTitleTypo: 'room-tab-title-typo',
  tabSubTitleTypo: 'room-tab-subtitle-typo',
  textField: 'room-textfield',

  overviewOuterBox: 'room-overview-outer-box',
  overviewLeftBox: 'room-overview-left-box',
  overviewGenInfoCard: 'room-overview-gen-info-card',
  overviewSensorInfoCard: 'room-overview-sensor-info-card',
  overviewLightAndTableBox: 'room-overview-light-and-table-box',
  overviewTableInfoCard: 'room-overview-table-info-card',
  overviewLightInfoCard: 'room-overview-light-info-card',
  overviewRightBox: 'room-overview-right-box',
  overviewSpecificsBox: 'room-overview-specifics-box',

  genInfoBox: 'room-geninfo-box',
  // genInfoTabTitleTypo: 'room-geninfo-tab-title-typo',
  // genInfoTabSubTitleTypo: 'room-geninfo-tab-subtitle-typo',
  genInfoDragBox: 'room-geninfo-drag-box',
  genInfoLeftDragBox: 'room-geninfo-left-drag-box',
  genInfoApiTitleTypo: 'room-geninfo-api-title-typo',
  genInfoApiSubTitleTypo: 'room-geninfo-api-subtitle-typo',
  genInfoMetrcRoomListBox: 'room-geninfo-metrcroomlist-box',
  genInfoMiddleDragBox: 'room-geninfo-middle-drag-box',
  genInfoMidRoomCardIcon: 'room-geninfo-mid-roomcard-icon',
  genInfoDragInfoTypo: 'room-geninfo-drag-info-typo',
  genInfoRightDragBox: 'room-geninfo-right-drag-box',
  genInfoDragTitleTypo: 'room-geninfo-drag-title-typo',
  genInfoRoomCardIcon: 'room-geninfo-roomcard-icon',
  genInfoDragSubTitleTypo: 'room-geninfo-drag-subtitle-typo',

  specificsBox: 'room-specifics-box',
  // specificsTabTitleTypo: 'room-specifics-tab-title-typo',
  // specificsSubTitleTypo: 'room-specifics-tab-subtitle-typo',

  sensorsBox: 'room-sensors-box',
  sensorsAECBtn: 'room-sensors-add-entity-card-button',
};

export const roomDetailClasses = {
  infoTypo: 'room-detail-info-typo',
  infoIcon: 'room-detail-info-icon',
  infoIconPaper: 'room-detail-info-icon-paper',
  itemInfoTypo: 'room-detail-item-info-typo',
  itemInfoInfoTypo: 'room-detail-item-info-info-typo',
  itemInfoIcon: 'room-detail-item-info-icon',
  wrapperPaper: 'room-detail-wrapper-paper',
  headerPaper: 'room-detail-header-paper',
  titlePaper: 'room-detail-title-paper',
  titleTypo: 'room-detail-title-typo',
  detailBreadcrumbTypo: 'room-detail-detail-breadcrumb-typo',
  saveBtn: 'room-detail-save-button',
  tabs: 'room-detail-tabs',
  tabIndicator: 'room-detail-tabindicator',
  tab: 'room-detail-tab',
  hideTab: 'room-detail-hide-tab',
  divider: 'room-detail-divider',
  detailOuterPaper: 'room-detail-detail-outer-paper',
  detailLeftPaper: 'room-detail-detail-left-paper',
  detailRightPaper: 'room-detail-detail-right-paper',
  lightAndTablePaper: 'room-detail-light-and-table-paper',
  detailGeneralBox: 'room-detail-detail-general-box',
  dragBox: 'room-detail-drag-box',
  leftDragBox: 'room-detail-left-drag-box',
  roomCardIcon: 'room-detail-card-icon',
  apiTitleTypo: 'room-detail-api-title-typo',
  apiSubTitleTypo: 'room-detail-api-subtitle-typo',
  metrcRoomListBox: 'room-detail-metrcroom-list-box',
  middleDragBox: 'room-detail-middle-drag-box',
  middleDragBoxIcon: 'room-detail-middle-drag-box-icon',
  dragInfoTypo: 'room-detail-drag-info-typo',
  rightDragBox: 'room-detail-right-drag-box',
  tabTitleTypo: 'room-detail-tab-title-typo',
  tabSubTypo: 'room-detail-tab-sub-typo',
  tabTextField: 'room-detail-tab-textfield',
  noMetrcRoomBox: 'room-detail-no-metrcroom-box',
  noMetrcRoomTypo: 'room-detail-no-metrcroom-typo',
  detailSpecificsPaper: 'room-detail-detail-specifics-paper',
  detailSensorsPaper: 'room-detail-detail-sensors-paper',
  sensorCardButton: 'room-detail-sensorcard-button',
  tablesBox: 'room-detail-tables-box',
  addTableCardButton: 'room-detail-addtablecard-button',
  detailLightsPaper: 'room-detail-detail-lights-paper',
  lightsTitleTypo: 'room-detail-lights-title-typo',
  lightsSubTypo: 'room-detail-lights-sub-typo',
  breadcrumbs: 'room-detail-breadcrumbs',
  breadcrumbsSepIcon: 'room-detail-breadcrumbs-sep-icon',
  isCard: 'room-detail-installation-specifics-card',
  textFieldAdornment: 'room-detail-textfield-adornment',
  filterTitleTypo: 'room-detail-filter-typo',
  chip: 'room-detail-chip',
  filterInput: 'room-detail-outlined-input',
  editIcon: 'room-detail-edit-icon',
  canCloneTable: 'can-clone-table',
};

export const roomTablePopupClasses = {
  addLevelBtn: 'roomtable-popup-add-level-button',
  addLevelBtnIcon: 'roomtable-popup-add-level-button-icon',
  descTypo: 'roomtable-popup-desc-typo',
  dimFields: 'roomtable-popup-dimension-textfield',
  divider: 'roomtable-popup-divider',
  levelEntryBox: 'roomtable-popup-level-entry-box',
  levelEntryCancelIcon: 'roomtable-popup-level-entry-cancel-icon',
  levelTypo: 'roomtable-popup-level-typo',
  levelsBox: 'roomtable-popup-levels-box',
  nameTypo: 'roomtable-popup-name-typo',
  textField: 'roomtable-popup-textfield',
};

export const roomTableCardClasses = {
  nameTypo: 'roomtable-card-name-typo',
  infoBox: 'roomtable-card-info-box',
  infoTypo: 'roomtable-card-info-typo',
  delBtn: 'roomtable-card-del-button',
  dotSepIcon: 'roomtable-card-dot-sep-icon',
  editIcon: 'roomtable-card-edit-icon',
  editDetailsBtn: 'roomtable-card-edit-button',

  baseEntityCardBox: 'roomtable-card-baseentitycard-box',
};

export const sensorCardClasses = {
  actionBtnBox: 'sensor-card-action-button-box',
  addedTable: 'sensor-card-added-table',
  attachTableIcon: 'sensor-card-attach-table-icon',
  attachTableBtn: 'sensor-card-attach-table-button',
  editDetailsBtn: 'sensor-card-edit-details-button',
  editIcon: 'sensor-card-edit-icon',
  delBtn: 'sensor-card-del-button',
  dotSepIcon: 'sensor-card-dot-separator-icon',
  infoBox: 'sensor-card-info-box',
  macTypo: 'sensor-card-mac-typo',
  roomTypo: 'sensor-card-room-typo',
  titleTypo: 'sensor-card-title-typo',
  typesTypo: 'sensor-card-types-typo',

  baseEntityCardBox: 'sensor-card-baseentitycard-box',
};

export const settingsClasses = {
  box: 'settings-box',
  titleTypo: 'settings-title-typo',
  devTypo: 'settings-dev-typo',
};

export const signUpPageClasses = {
  box: 'signup-page-box',
  infoTypo: 'signup-page-info-typo',
  actionTypo: 'signup-page-action-typo',
  nameBox: 'signup-page-name-box',
  formBox: 'signup-page-form-box',
  nextActionTypo: 'signup-page-next-action-typo',
  resendCodeBtn: 'signup-page-resend-code-button',
  showPasswordIcon: 'signup-page-show-password-icon',
  mailIcon: 'signup-page-mail-icon',
  textField: 'signup-page-textfield',
  proceedBtn: 'signup-page-proceed-button',
  enterActionTypo: 'signup-page-enter-action-typo',
  resendActionTypo: 'signup-page-resend-action-typo',
  instructionsBox: 'signup-page-instructions-box',
  instructionTypo: 'signup-page-instruction-typo',
  basicSetupComplete: 'signup-page-basic-setup-complete',
  allowFarmAdd: 'signup-page-allow-farm-add',
};

export const tableClasses = {
  displayTable: {
    tableContainer: 'display-table-table-container',
    table: 'display-table-table',
    tableRow: 'display-table-table-row',
    titleCell: 'display-table-title-cell',
    entryCell: 'display-table-entry-cell',
    noEntityTableCell: 'display-table-no-entity-table-cell',
    tableFooterPaper: 'display-table-table-footer-paper',
    addBtn: 'display-table-add-button',
    pagination: 'display-table-pagination',
  },
  displayTableWithDropdown: {
    tableContainer: 'display-table-with-dropdown-table-container',
    table: 'display-table-with-dropdown-table',
    tableRow: 'display-table-with-dropdown-table-row',
    titleCell: 'display-table-with-dropdown-title-cell',
    entryCell: 'display-table-with-dropdown-entry-cell',
    noEntityTableCell: 'display-table-with-dropdown-no-entity-table-cell',
    tableFooterPaper: 'display-table-with-dropdown-table-footer-paper',
    addBtn: 'display-table-with-dropdown-add-button',
  },
  inProdInv: {
    box: 'in-production-inv-table-box',
    titleBox: 'in-production-inv-table-title-box',
    titleTypo: 'in-production-inv-table-title-typo',
    button: 'in-production-inv-table-button',
    tableBox: 'in-production-inv-table-table-box',
    entryRowTitleTypo: 'in-production-inv-table-entry-row-title-typo',
    entryValueTypo: 'in-production-inv-table-entry-value-typo',
    tableHeader: 'table-header',
    // rowHeadersBox: 'in-production-inv-table-row-headers-box',
    // rowHeaderTypo: 'in-production-inv-table-row-header-typo',
    // entriesBox: 'in-production-inv-table-entries-box',
    // tableEntryBox: 'in-production-inv-table-entry-box',
    // entryHeaderTypo: 'in-production-inv-table-entry-header-typo',
    // entryValueTypo: 'in-production-inv-table-entry-value-typo',
  },
};

export const wizardClasses = {
  base: {
    box: 'wizard-base-box',
    contentBox: 'wizard-base-content-box',
    leftBox: 'wizard-base-left-box',
    ringBox: 'wizard-base-ring-box',
    infoTypo: 'wizard-base-info-typo',
    infoSubTypo: 'wizard-base-info-sub-typo',
    actionBtn: 'wizard-base-action-button',
    rightBox: 'wizard-base-right-box',
    todoTypo: 'wizard-base-todo-typo',
    todoListBox: 'wizard-base-todo-list-box',
    stepConnectorIcon: 'wizard-base-step-connector-icon',
    todoItemBox: 'wizard-base-todo-item-box',
    stepStatusIcon: 'wizard-base-step-status-icon',
    todoStepTypo: 'wizard-base-todo-step-typo',
    currStep: 'wizard-base-curr-step',
  },
  farms: {
    box: 'wizard-farms-box',
    contentBox: 'wizard-farms-content-box',
    leftBox: 'wizard-farms-left-box',
    ringBox: 'wizard-farms-ring-box',
    infoTypo: 'wizard-farms-info-typo',
    infoSubTypo: 'wizard-farms-info-sub-typo',
    actionBtn: 'wizard-farms-action-button',
    rightBox: 'wizard-farms-right-box',
    todoTypo: 'wizard-farms-todo-typo',
    todoListBox: 'wizard-farms-todo-list-box',
    stepConnectorIcon: 'wizard-farms-step-connector-icon',
    todoItemBox: 'wizard-farms-todo-item-box',
    stepStatusIcon: 'wizard-farms-step-status-icon',
    todoStepTypo: 'wizard-farms-todo-step-typo',
    currStep: 'wizard-farms-curr-step',
  },
  plans: {
    box: 'wizard-plans-box',
    contentBox: 'wizard-plans-content-box',
    leftBox: 'wizard-plans-left-box',
    ringBox: 'wizard-plans-ring-box',
    rightBox: 'wizard-plans-right-box',
  },
};

export const timelineClasses = {
  timeline: 'entity-detail-timeline',
  timelineItem: 'entity-detail-timeline-item',
  timelineSeparator: 'entity-detail-timeline-separator',
  timelineDot: 'entity-detail-timeline-dot',
  timelineConnector: 'entity-detail-timeline-connector',
  specialTimelineSeparator: 'entity-detail-level-completed-timeline-separator',
  specialTimelineConnector: 'entity-detail-level-completed-timeline-connector',
  specialTimelineDot: 'entity-detail-level-completed-timeline-dot',
  expandedDot: 'entity-detail-default-expanded-timeline-dot',
  accordionSummary: 'entity-detail-timeline-accordion-summary',
  accordionDetail: 'entity-detail-timeline-accordion-detail',
};

export const commandCenterClasses = {
  box: 'command-center-root-container',
  headerBox: 'command-center-header-container',
  titleBox: 'command-center-title-box',
  titleTypo: 'command-center-title-typo',
  saveBtn: 'command-center-save-button',
  circularProgress: 'command-center-circular-progress',
  icon: 'command-center-icon',
  modalContainer: 'command-center-modal-container',
};

export const generalFunctionClasses = {
  box: 'popper-box',
  // stepper:{ },
  popper: {
    titleTypo: 'popper-title-typo',
    closeIconBox: 'popper-icon-box',
  },
};

// export const bucketDetailsClasses = {
//         box: 'bucket-details-box',
//         titleTypo: 'bucket-details-title-typo',
// }

// Frontend utility functions

export const defFunc = console.log;

export const checkTempRefOrId = (value, reference) => (value?.id && value?.id === reference) || (value?.tempRef && value?.tempRef === reference);

export const getHarvestTableDate = dateVal => {
  const date = isNaN(Date.parse(dateVal)) ? null : new Date(dateVal);

  const weekDay = date?.toLocaleDateString?.(undefined, { weekday: 'short' }) ?? '';

  let day = date?.getDate?.() ?? '';
  day += day === 1 ? 'st' : day === 2 ? 'nd' : day === 3 ? 'rd' : day > 3 ? 'th' : '';

  const month = date?.toLocaleDateString?.(undefined, { month: 'short' }) ?? '';

  const result = `${weekDay} ${day} ${month}`;

  return result;
  // return ({
  //         year: date?.getFullYear(),
  //         result,
  // });
};

export const getFullHarvestTableDate = dateVal => {
  const year = isNaN(Date.parse(dateVal)) ? '' : new Date(dateVal).getFullYear();

  const result = getHarvestTableDate(dateVal) + ' ' + year;

  return result;
};

export const getValidNumOrZero = num => {
  return (!num && num !== 0) || isNaN(+num) ? 0 : +num;
};

export const getDollarFormatNum = (val, fractionDigits = 2) => {
  if (!val || isNaN(+val)) {
    val = 0;
  }

  // let num = fractionDigits > 0 ? parseFloat(val).toFixed(fractionDigits) : parseInt(val);
  let num = parseFloat(val).toFixed(2);

  const styleOptions = {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: fractionDigits,
  };

  return Number(num).toLocaleString('en-US', styleOptions);
};

export const getDollarSuffixNum = (val, fractionDigits = 2) => {
  if (isNaN(+val)) {
    val = 0;
  }

  const trillion = 1000000000000;
  const billion = 1000000000;
  const million = 1000000;
  const thousand = 1000;

  let suffix = '';

  if (+val >= trillion) {
    val /= trillion;
    suffix = 'T';
  } else if (+val >= billion) {
    val /= billion;
    suffix = 'B';
  } else if (+val >= million) {
    val /= million;
    suffix = 'M';
  } else if (+val >= thousand) {
    val /= thousand;
    suffix = 'K';
  }

  const styleOptions = {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: fractionDigits,
  };

  return `${Number(val).toLocaleString('en-US', styleOptions)} ${suffix}`;
};

// export const getFixedDecimalVal = (digits=1) => val => parseFloat(isNaN(+val) ? 0 : val).toFixed(digits);
export const getFixedDecimalVal =
  (digits = 1) =>
  val => {
    const num = parseFloat(val);
    if (isNaN(num)) return (0).toFixed(digits);
    return num.toFixed(digits);
  };

export const getDashStatValue = (entry, idx) => propMapEntry => {
  const value = entry?.[propMapEntry?.prop];

  return propMapEntry?.isIndex
    ? idx + 1
    : propMapEntry?.isNumber
      ? (propMapEntry?.formatNumFn?.(value) ?? value) // can also send formatNumberFn in propMapEntry
      : (propMapEntry?.propFn?.(entry) ?? value);
};

export const getTimezoneSansLocaleDate = (date, locale = 'en-US', returnVal = '', options = {}) => {
  if (isNaN(Date.parse(date))) return returnVal;

  let dateWithTZ = new Date(date);
  let dateWithoutTZ = new Date(dateWithTZ.toISOString().slice(0, -1));

  return dateWithoutTZ.toLocaleDateString(locale, options);
};

export const getFormattedTime = (time, locale = 'en-US', returnVal = '', options = { hour: '2-digit', minute: '2-digit' }) => {
  let date;
  if (!isNaN(Date.parse(time))) {
    date = new Date(time);
    return date.toLocaleTimeString();
  }

  date = new Date(`1999-01-01T${time}`);

  if (isNaN(Date.parse(date))) return returnVal;
  return date.toLocaleTimeString(locale, options);
};

export const getFormattedTableEntry = (value, mapEntry) => {
  // mapEntry={key: '', title: '', ...others}

  return mapEntry?.isNum ? +value?.[mapEntry?.key] : mapEntry?.isDate ? getTimezoneSansLocaleDate(value?.[mapEntry?.key]) : value?.[mapEntry?.key];
};

export const convertHoursToDaysAndHours = totalHours => {
  const days = Math.floor(totalHours / 24); // Calculate the full days
  const hours = totalHours % 24;
  let final = '';
  if (days) {
    final = `${days} Days`;
  }
  if (hours) {
    final = `0 Days ${hours} Hrs`;
  }
  if (days && hours) {
    final = `${days} Days ${hours} Hrs`;
  }
  // Calculate the remaining hours
  return final;
};

export const logoutUser = () => {
  const themeMode = localStorage.getItem('themeMode');

  const wizards = [FARM_WIZARD_TYPE, PLAN_WIZARD_TYPE];

  const wizardState = wizards.map(e => ({ key: e, value: getWizardDetails(e) }));

  localStorage.clear();
  sessionStorage.clear();

  if (themeMode === LIGHT_MODE || themeMode === DARK_MODE) {
    localStorage.setItem('themeMode', themeMode);
  }

  wizardState?.forEach(val => {
    setWizardDetails(val?.key, val?.value);
  });
};

export const getFarmWizardDetails = () => {
  const details = JSON.parse(localStorage?.farmWizardSteps ?? '{}');

  return details;
};

export const setFarmWizardDetails = (prop, value) => {
  localStorage.farmWizardSteps = JSON.stringify({
    ...JSON.parse(localStorage?.farmWizardSteps ?? '{}'),

    [prop]: value,
  });

  return true;
};

export const getWizardDetails = wizardType => JSON.parse(localStorage?.[wizardType] ?? '{}');

export const setWizardDetails = (wizardType, values = {}) => {
  if (!wizardType) return false;

  localStorage[wizardType] = JSON.stringify({
    ...JSON.parse(localStorage?.[wizardType] ?? '{}'),
    ...values,
  });

  return true;
};

export const getWizardRoute = (wizardType, actionType, defRoute = landingPageRoute) => {
  const wizRoute = wizardTypeRouteMap?.[wizardType];

  if (!wizardType || (!actionType && actionType !== 0) || !wizRoute) return defRoute;

  const { action, execute } = getWizardDetails(wizardType);

  if (execute && action === actionType) {
    const res = { lastStepCompleted: true };

    setWizardDetails(wizardType, res);

    return wizRoute;
  } else {
    return defRoute;
  }
};

export const errFeedbackFn =
  (config = {}) =>
  err => ({
    // 18-04-2023: TODO: Add more conditions for common error status codes
    message:
      err?.response?.status === 500
        ? (config?.['500'] ?? 'Internal Server Error. We regret the inconvenience') // Do not null coallesce for 500 errors as they might contain entire auto-generated template form django
        : err?.response?.status === 404
          ? (config?.['404'] ?? err?.response?.data?.text ?? 'The resource was not found')
          : err?.response?.status === 400
            ? (config?.['400'] ??
              err?.response?.data?.text ??
              (config?.create
                ? `${config?.resource ?? 'The resource'} could not be created. Please review your inputs`
                : 'Invalid modification request. Please review your changes'))
            : err?.response?.status === 0
              ? (config?.['0'] ?? 'The server could not be reached') // 17-04-2023: TODO: Verfiy if this condition is reliable
              : (config?.finalErrMsg ?? err?.response?.data?.text ?? 'An error occured. We regret the inconvenience'),

    severity: config?.severity ?? 'error',
  });

export const getHandleErrorWithFeedback =
  (handleSetValues, otherFeedbackProps = {}, logCheck = false) =>
  errPropsFn =>
  err => {
    if (logCheck) {
      console.log('An error occured');
      console.log(err);
    }

    const errProps = errPropsFn?.(err) ?? defErrProps;

    const feedbackProps = {
      ...errProps,
      ...otherFeedbackProps,
    };

    handleSetValues?.('feedback', true);
    handleSetValues?.('feedbackProps', feedbackProps);
  };

export const getHandleErrorWithFeedbackCX = feedbackCX => errPropsFn => err => {
  const errProps = errPropsFn?.(err) ?? defErrProps;

  feedbackCX?.setContextValue?.(true, errProps);
};

export const getCharWithEllipsis = (str = '', charCount = 20) => (str?.length > charCount ? `${str.substring(0, charCount)}...` : str);

export const GRAMS = 'grams';
export const LBS = 'lbs';

export const convertWeight =
  (from = GRAMS, to = LBS, fractionDigits = 2) =>
  (value = 0) => {
    switch (from) {
      case GRAMS: {
        if (to === LBS) {
          // const val = +value * 0.00220462262185;
          const val = +value * 0.0022; // Keep in sync with backend

          return getFixedDecimalVal(fractionDigits)(val);
        }
        return value;
      }

      default:
        return value;
    }
  };

export const sortByID = (a, b) => +a?.id - +b?.id;

export const LIGHT_MODE = 'light';
export const DARK_MODE = 'dark';
export const DARK_THEME_CLASS = 'dark-theme';
// export const getDarkThemeClass = theme => theme?.palette?.mode === DARK_MODE ? DARK_THEME_CLASS : '';
export const getDarkThemeClass = theme => (theme?.palette?.themeMode === DARK_MODE ? DARK_THEME_CLASS : '');

export const NEW = 'new';

// Defaults
export const defDefsForRevenueColumnGradientID = 'paint0_linear_883_570';
export const defEmptyText = '';
export const defEmptyPropsFn = () => ({});
export const defEmptyArr = [];
export const defUndVal = '';
export const lorem =
  "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s";
export const defErrProps = { message: 'Operation failed', severity: 'error' };

// Frontend routes
// export const baseTestRoute = '/test/farms/farm/:farmid/room/:roomid';
export const baseTestRoute = '/test/';
export const cropsHomeRoute = '/crops';
export const defaultNoAccountRoute = '/signup';
export const defaultNoAuthRoute = '/login';
export const defaultNoMetrcRoute = '/organization-setup';
// export const farmDashboardRoute = '/farms?tab=farms';
export const organizationHomeRoute = '/organization';
export const configurationsHomeRoute = '/configurations';
export const configurationMetricRunGenNewAndDetailRoute = `${configurationsHomeRoute}/metricplan/:metricplanid`;
export const getMetricPlanRoute = id => `${configurationsHomeRoute}/metricplan/${id}`;
export const configurationDefaultRoutineNewAndDetailRoute = `${configurationsHomeRoute}/default-routine/:defaultroutineid`;
export const getDefaultRoutineRoute = id => `${configurationsHomeRoute}/default-routine/${id}`;
export const farmByIdRoute = `${configurationsHomeRoute}/farm/:farmid`;
export const farmsRoute = '/farms';
export const farmsHomeRoute = `${configurationsHomeRoute}?tab=farms`;
export const farmsHomeWithTabRoute = `${configurationsHomeRoute}?tab=farms`;
export const farmsHomeWithRoomsTabRoute = `${configurationsHomeRoute}?tab=farms`;
export const farmDashboardRoute = '/dashboard';
export const farmsWizardRoute = '/farms-wizard';
export const landingPageRoute = '/';
export const plansHomeRoute = '/plans';

export const cropPlanHomeRoute = '/crop-plans';
export const cropPlanHomeWithTabRoute = '/crop-plans?tab=crop-plans';
export const cropPlanGenNewAndDetailRoute = `${cropPlanHomeRoute}/cropplan/:cropplanid`;
export const cropPlanNewAndDetailRoute = `${cropPlanHomeRoute}/cropplan`;

export const logisticsHomeRoute = '/logistics';
export const logisticsHomeWithTabRoute = `${logisticsHomeRoute}?tab=metrc-tag`;

export const routinesHomeRoute = '/configurations?tab=routines';
export const createNewRoutineEndpoint = '/configurations/default-routine/new/?tab=specifics';

export const cropsHomeWithTabRoute = `${cropsHomeRoute}?tab=runs`;
export const cropsPlanGenNewAndDetailRoute = `${cropsHomeRoute}/plans/:cropplanid`;
export const cropsPlanNewAndDetailRoute = `${cropsHomeRoute}/plans`;
export const cropsRunGenNewAndDetailRoute = `${cropsHomeRoute}/runs/:cropplanid`;
export const cropsRunNewAndDetailRoute = `${cropsHomeRoute}/runs`;
export const cropsHistoryGenNewAndDetailRoute = `${cropsHomeRoute}/history/:cropplanid`;
export const cropsHistoryNewAndDetailRoute = `${cropsHomeRoute}/history`;

export const growExecutiveRoute = `/executive`;
export const growCommandCenter = '/command-center';
export const growTransferManifestRoute = '/transfer';

export const externalItemDetailRoute = `/integration/:integrationid/items`;
export const externalWasteDetailRoute = `/integration/:integrationid/waste`;
export const externalUnitDetailRoute = `/integration/:integrationid/unit`;
export const externalLabTestsDetailRoute = '/integration/:integrationid/lab-tests';
export const externalMetrcTagsDetailRoute = `/integration/:integrationid/metrc-tags`;
export const externalMetrcTransportersRoute = `/integration/:integrationid/metrc-transporters`;
export const externalMetrcFacilityEmployeesRoute = `integration/:integrationid/facility-employees`;
export const externalGenNewAndDetailRoute = `/integration/:integrationid`;
export const externalNewAndDetailRoute = `/integration`;

export const growPlanGenNewAndDetailRoute = `${plansHomeRoute}/growplan/:growplanid`;
export const growPlanNewAndDetailRoute = `${plansHomeRoute}/growplan`;

export const metricPlanGenNewAndDetailRoute = `${plansHomeRoute}/metricplan/:metricplanid`;
export const metricPlanNewAndDetailRoute = `${plansHomeRoute}/metricplan`;

export const phasePlanGenNewAndDetailRoute = `${configurationsHomeRoute}/phaseplan/:phaseplanid`;
export const phasePlanNewAndDetailRoute = `${configurationsHomeRoute}/phaseplan`;
export const routineNewAndDetailRoute = `${configurationsHomeRoute}/default-routine`;

export const plansHomeWithTabRoute = `${plansHomeRoute}?tab=grow-plans`;
export const plansHomeWithMetricPlanTabRoute = `${plansHomeRoute}?tab=metrics`;
export const plansWizardRoute = '/plans-wizard';
// export const plansWizardRoute = '/test';

export const qualityPlanGenNewAndDetailRoute = `${configurationsHomeRoute}/qualityplan/:qualityplanid`;
export const qualityPlanNewAndDetailRoute = `${configurationsHomeRoute}/qualityplan`;

export const getRoomDetailRoute = (farmid, roomid) => `${configurationsHomeRoute}/farm/${farmid}/room/${roomid}`;

export const cropRunHomeRoute = '/crop-runs';
export const cropRunGenNewAndDetailRoute = `${cropRunHomeRoute}/croprun/:cropplanid`;
export const cropRunNewAndDetailRoute = `${cropRunHomeRoute}/croprun`;

// Backend routes
export const listCropPlanEndpoint = `cropplan/`;
export const newCropPlanEndpoint = `${NEW}/${listCropPlanEndpoint}`;
// export const detailCropPlanEndpoint = id => `${listCropPlanEndpoint}${id}/`;
export const detailCropPlanEndpoint = (id, status) => `${listCropPlanEndpoint}${id}/?status=${status}`;
export const cropplanStrainEndpoint = id => `cropplan-strain/${id}/`;

export const allCropRunEndpoint = `croprun/`; // Will exist in future ?

export const detailGrowPlanEndpoint = id => `growplan/${id}/`;
export const listGrowPlanEndpoint = `growplan/`;
export const newGrowPlanEndpoint = `${listGrowPlanEndpoint}${NEW}/`;

export const listMetricPlanEndpoint = `metricplan/`;
export const detailMetricPlanEndpoint = id => `${listMetricPlanEndpoint}${id}/`;

export const defaultRoutineEndpoint = `defaultroutine/`;

export const listOrgEndpoint = `organization/`;
export const detailOrgEndpoint = id => `${listOrgEndpoint}${id}/`;

export const listPhasePlanEndpoint = `phaseplan/`;
export const detailPhasePlanEndpoint = id => `${listPhasePlanEndpoint}${id}/`;

export const listQualityPlanEndpoint = `qualityplan/`;
export const detailQualityPlanEndpoint = id => `${listQualityPlanEndpoint}${id}/`;

export const getNewEntityDepsEndpoint = entity => `new/${entity}/`;
export const getNewEntityDepsEndpoints = (entity, id) => `new/${entity}/?id=${id}`;

// export const getGrowDashboardEndpoint = `grow-dashboard/`;
// export const getGrowDashboardEndpoint = `harvests/by-status/?farm_id=1`;

export const getGrowDashboardForecastEndpoint = id => `grow-dashboard-forecast/${id}/`;

export const plansCollectionEndpoint = `collection/plan/`;
export const cropsCollectionEndpoint = `collection/crops/`;
export const farmsCollectionEndpoint = `collection/farm/`;

export const commandHomeEndpoint = `command-center/home/`;

export const metrcTagsEndpoint = 'metrc-tag/';
export const detailMetrcTagEndpoint = id => `${metrcTagsEndpoint}${id}`;

export const routinesCreateEndpoint = `setup-routines/`;

export const endpoints = {
  // newer approach for exporting similar type of contants
  harvest: {
    list: 'harvest/',
  },
  farm: {
    list: 'farm/',
    detail: id => `farm/${id}/`,
  },
  roomtable: {
    list: `room-table/`,
    detail: id => `room-table/${id}/`,
  },
  sensor: {
    list: `sensors/`,
    detail: id => `sensors/${id}/`,
  },
  sensor_metric: {
    detail: id => `sensor-metric/${id}/`,
  },
  routine: {
    detail: id => `cropplan-routines/${id}/`,
  },
  default_routine: {
    detail: id => `cropplan/default-routine/${id}/`,
    new: `${NEW}/defaultroutine/`,
  },
  metrc: {
    list: `metrc-key/`,
    detail: id => `metrc-key/${id}/`,
  },
};

export const createAction = 'add';
export const readAction = 'view';
export const updateAction = 'change';
export const deleteAction = 'delete';

// Content Type Labels

export const accountAppLabel = 'account';
export const cropPlanAppLabel = 'cropplan';
export const farmAppLabel = 'farm';
export const growPlanAppLabel = 'growplan';
export const qualityPlanAppLabel = 'qualityplan';

export const cropPlanModelName = 'cropplan'; // Will exist in future ?
export const dashboardModelName = 'grow_dashboard';
export const farmModelName = 'farm';
export const growPlanModelName = 'growplan';
export const lightModelName = 'light';
export const metrcPlanModelName = 'metrcplan';
export const phasePlanModelName = 'phaseplan';
export const metrcPlanCycleModelName = 'metrcplancycle';
export const metrcRoomModelName = 'metrcroom';
export const qualityPlanModelName = 'qualityplan';
export const roomModelName = 'room';
export const sensorModelName = 'sensor';
export const strainModelName = 'strain';
export const tableModelName = 'roomtable';
export const metrcRunModelName = 'metrcruns';
export const defaultRoutineModelName = 'defaultroutine';

export const crudActions = {
  create: createAction,
  read: readAction,
  update: updateAction,
  delete: deleteAction,
};

export const entityModelMap = {
  // DisplayName: ContentTypeModelName
  Farms: {
    contenttype: 'farm',
  },
  Executive: {
    allowActions: ['view'],
    contenttype: 'grow_dashboard',
    isCustomPerm: true,
  },
  'Command View': {
    contenttype: 'commandview',
    allowActions: ['view', 'change'],
    isCustomPerm: true,
  },
  'Command Crop Run': {
    contenttype: 'commandcroprun',
    allowActions: ['view', 'change'],
    isCustomPerm: true,
  },
  Rooms: {
    contenttype: 'room',
  },
  Strains: {
    contenttype: 'strain',
  },
  'Crop Plans': {
    contenttype: 'cropplan',
  },
  'Grow Plans': {
    contenttype: 'growplan',
  },
  'Quality Plans': {
    contenttype: 'qualityplan',
  },
  'Metric Plans': {
    contenttype: 'metrcplan',
  },
  'Phase Plans': {
    contenttype: 'phaseplan',
  },
  'Config Routines': {
    contenttype: 'defaultroutine',
  },
  'Crop Plan Routines': {
    contenttype: 'routines',
    parent: 'cropplan',
  },
};

export const contentTypeNamesMap = {
  farm: 'Farm',
  grow_dashboard: 'Executive',
  commandview: 'Command View',
  commandcroprun: 'Command Crop Run',
  room: 'Room',
  sensor: 'Sensor',
  strain: 'Strain',
  cropplan: 'Crop Plan',
  growplan: 'Grow Plan',
  qualityplan: 'Quality Plan',
  metrcplan: 'Metric Plan',
  phaseplan: 'Phase Plan',
  defaultroutine: 'Config Routine',
  routines: 'Crop Plan Routines',
};

// export const entityModelMap = {
//         // DisplayName: ContentTypeModelName
//         Farms: 'farm',
//         Rooms: 'room',
//         Sensors: 'sensor',
//         // Lights: 'light',
//         Strains: 'strain',
//         // 'Room Tables': 'roomtable',

//         'Crop Plans': 'cropplan',
//         'Grow Plans': 'growplan',
//         'Quality Plans': 'qualityplan',
//         'Metric Plans': 'metrcplan',
// };
export const contactUsRoute = '/contact-us';

export const otherRoomCreatePermissions = ['view_sensor', 'add_sensor', 'view_light', 'add_light', 'view_roomtable', 'add_roomtable'];

export const metrcPlanIconMap = {
  1: MoistureIcon,
  2: NutritionIcon,
  3: ECIcon,
};

export const noPermTablePrefixMsg = 'You do not have permission to view';

export const wizardTypeRouteMap = {
  [FARM_WIZARD_TYPE]: farmsWizardRoute,
  [PLAN_WIZARD_TYPE]: plansWizardRoute,
};

// Constants
export const HARVEST_TYPE_ACTIVE = 'Active';
export const HARVEST_TYPE_INACTIVE = 'Inactive';

// Check keys list

const zeroCheck = val => val !== 0;

export const cropplanNewKeys = ['name', 'target_subphase', 'target_subphase_date', 'phaseplan', 'qualityplan', 'owner'];
export const growplanNewKeys = ['name', 'description', 'room', 'medium_profile', 'qualityplan', 'phaseplan'];
export const phaseplanNewKeys = ['name', 'description'];
export const subphaseplanNewKeys = ['start_day', 'end_day'];
export const checkKeys = {
  roomTable: [
    { key: 'name', checkFn: zeroCheck },
    { key: 'width', checkFn: zeroCheck },
    { key: 'length', checkFn: zeroCheck },
    { key: 'levels', checkFn: val => val?.levels?.length < 1 },
  ],
};

// nodeName
export const nodeNames = {
  // namespacing for avoiding name conflicts and easy export
  INPUT: 'INPUT',
  TEXTAREA: 'TEXTAREA',
};

// Not finalised
export const tableMaxWd = 1220;

// Development helpers
export const showConsole = true;
export const logMsgToConsole = {
  axios: false,
  crop: false,
  crops: false,
  dashboard: false,
  growplan: false,
  inProdInv: false,
  metricplan: false,
  organization: false,
  phaseplan: false,
  plans: false,
  qualityplan: true,
  roomDetail: false,
  cropPlan: false,
  defaultRoutine: false,
  cropPlansTabs: {
    phases: false,
  },

  popups: {
    roomtable: false,
    sensor: false,
    routine: false,
  },
};
export const countryCodes = [
  { code: '+1', name: 'United States' },
  { code: '+91', name: 'India' },
  { code: '+44', name: 'United Kingdom' },
  { code: '+61', name: 'Australia' },
  { code: '+81', name: 'Japan' },
  { code: '+49', name: 'Germany' },
  { code: '+33', name: 'France' },
  { code: '+86', name: 'China' },
  { code: '+7', name: 'Russia' },
  { code: '+39', name: 'Italy' },
  { code: '+34', name: 'Spain' },
  { code: '+55', name: 'Brazil' },
  { code: '+27', name: 'South Africa' },
  { code: '+971', name: 'United Arab Emirates' },
  { code: '+966', name: 'Saudi Arabia' },
  { code: '+92', name: 'Pakistan' },
  { code: '+880', name: 'Bangladesh' },
  { code: '+20', name: 'Egypt' },
  { code: '+82', name: 'South Korea' },
  { code: '+63', name: 'Philippines' },
  { code: '+62', name: 'Indonesia' },
  { code: '+98', name: 'Iran' },
  { code: '+234', name: 'Nigeria' },
  { code: '+60', name: 'Malaysia' },
  { code: '+94', name: 'Sri Lanka' },
  { code: '+31', name: 'Netherlands' },
  { code: '+352', name: 'Luxembourg' },
  { code: '+972', name: 'Israel' },
  { code: '+90', name: 'Turkey' },
  { code: '+351', name: 'Portugal' },
  { code: '+994', name: 'Azerbaijan' },
  { code: '+36', name: 'Hungary' },
  { code: '+373', name: 'Moldova' },
  { code: '+389', name: 'North Macedonia' },
  { code: '+40', name: 'Romania' },
  { code: '+380', name: 'Ukraine' },
  { code: '+359', name: 'Bulgaria' },
  { code: '+386', name: 'Slovenia' },
  { code: '+421', name: 'Slovakia' },
  { code: '+48', name: 'Poland' },
  { code: '+45', name: 'Denmark' },
  { code: '+46', name: 'Sweden' },
  { code: '+47', name: 'Norway' },
  { code: '+41', name: 'Switzerland' },
  { code: '+43', name: 'Austria' },
  { code: '+420', name: 'Czech Republic' },
  { code: '+998', name: 'Uzbekistan' },
  { code: '+84', name: 'Vietnam' },
  { code: '+856', name: 'Laos' },
  { code: '+855', name: 'Cambodia' },
  { code: '+65', name: 'Singapore' },
];
